{
  "account.account": "Profil a zabezpečení",
  "account.accountDeleted": "Váš účet byl úspěšně smazán.",
  "account.accountDescription": "Jméno, heslo, smazání účtu",
  "account.accountSection": "Účet",
  "account.changeEmail": "Změnit e-mail",
  "account.changePassword": "Změna hesla",
  "account.currentPassword": "Aktuální heslo",
  "account.dangerZone": "Riziková zóna",
  "account.deleteAccount": "Smazat účet",
  "account.deleteAccountConfirmation": "Opravdu chcete smazat svůj účet? Tato akce je nevratná.",
  "account.deleteAccountDescription": "Tato akce smaže váš účet a všechny vaše informace. Není cesty zpět.",
  "account.emailChange": "Změnit e-mailovou adresu",
  "account.emailChangeConfirmation": "Potvrzení změny e-mailu",
  "account.emailChangeFailure": "Odkaz pro změnu e-mailu je neplatný nebo vypršel.",
  "account.emailChangeIntro": "Zadejte svou novou e-mailovou adresu a aktuální heslo. Na novou adresu vám pošleme odkaz: e-mail se změní až po jeho otevření.",
  "account.emailChangeSuccess": "Váš e-mail byl úspěšně změněn na {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Vaše e-mailová adresa byla úspěšně změněna.",
  "account.emailChangeVerificationSent": "Na vaši novou e-mailovou adresu byl odeslán ověřovací e-mail. Zkontrolujte svou doručenou poštu a klikněte na odkaz pro potvrzení změny.",
  "account.manageAccount": "Spravovat účet",
  "account.newEmailAddress": "Nová e-mailová adresa",
  "account.newPassword": "Nové heslo",
  "account.newPasswordAgain": "Nové heslo (podruhé)",
  "account.oldPassword": "Staré heslo",
  "account.passwordChange": "Změna hesla",
  "account.passwordChangeDescription": "Udržujte svůj účet v bezpečí",
  "account.passwordUpdated": "Heslo úspěšně aktualizováno.",
  "account.profile": "Profil uživatele",
  "account.profileUpdated": "Profil byl úspěšně aktualizován.",
  "account.signedInAs": "Přihlášen jako",
  "account.updateYourProfile": "Aktualizujte svůj profil",
  "account.updateYourProfileDescription": "Jméno a předvolby zobrazení",
  "addons.accountOnHold": "Připojení vašeho účtu vypršelo. Pro obnovení aktualizací dat se prosím znovu připojte.",
  "addons.accountOnHoldTitle": "Účet pozastaven",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Vytvořte a získejte klíč API z tohoto odkazu",
  "addons.ambientWeatherDescription": "Meteorologické stanice Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API klíč",
  "addons.applicationKey": "Aplikační klíč",
  "addons.availableServices": "Dostupné",
  "addons.cannotDisconnectLastAccount": "Nelze odpojit jedinou metodu přihlášení. Nejprve přidejte jinou metodu přihlášení.",
  "addons.connect": "Připojit",
  "addons.connected": "Připojeno",
  "addons.connectedAccounts": "Propojené účty",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedAccountsLoading": "Načítání propojených účtů…",
  "addons.connectedServices": "Připojeno",
  "addons.connectedSince": "Připojeno od {date}",
  "addons.connectionSection": "Připojení",
  "addons.connectionSuccess": "Účet {provider} úspěšně připojen",
  "addons.davisApiSecret": "Tajný klíč API",
  "addons.davisApiV2Key": "Klíč API V2",
  "addons.davisDescription": "Davis meteorologické stanice (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Získejte své klíče API V2 z tohoto odkazu",
  "addons.disconnect": "Odpojit",
  "addons.disconnectConfirmation": "Opravdu chcete odpojit svůj účet {provider}?",
  "addons.disconnectEnergyConfirmation": "SmartMixin přestane synchronizovat službu Netatmo Energy a odebere vaše domácnosti ze SmartMixinu. Váš účet Netatmo ani vaše zařízení tím nebudou dotčeny.",
  "addons.disconnectEnergyDescription": "Zastaví synchronizaci a odebere vaše domácnosti ze SmartMixinu.",
  "addons.disconnectionSuccess": "Účet {provider} úspěšně odpojen",
  "addons.disconnectProviderDescription": "Zastaví synchronizaci a smaže stanice této služby včetně jejich historie.",
  "addons.disconnectServiceConfirmation": "SmartMixin přestane synchronizovat službu {provider} a smaže její stanice včetně celé jejich historie. Váš účet {provider} samotný tím nebude dotčen.",
  "addons.disconnectServiceTitle": "Odpojit službu {provider}?",
  "addons.ecowittCreateAndRetrieveKeys": "Vytvořte a načtěte klíč API a klíč aplikace z tohoto odkazu",
  "addons.ecowittDescription": "Ecowitt poskytuje profesionální meteostanice, bezdrátové vnitřní/venkovní teploměry, vysoce přesné srážkoměry, senzory kvality vzduchu a mnoho dalšího.",
  "addons.helpLink": "Jak připojit {provider}",
  "addons.integrationsSection": "Integrace",
  "addons.myAcuriteAccountOnHold": "Váš účet byl pozastaven. Chcete-li znovu připojit svůj účet, zadejte své heslo",
  "addons.myAcuriteDescription": "AcuRite je značka meteostanic číslo 1 v Severní Americe. Jako lídr v technologii času, teploty a počasí vám AcuRite poskytuje podrobné informace o vašem vnitřním a venkovním prostředí, abyste si mohli s jistotou naplánovat svůj den.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Pomocí termostatu Netatmo můžete měnit teplotu svého domova z postele nebo z druhé strany světa.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Vaše osobní meteostanice doma",
  "addons.notConnected": "Nepřipojeno",
  "addons.or": "nebo",
  "addons.providerAccountDisconnected": "Připojení k vaší meteorologické službě vypršelo. Pro obnovení aktualizací dat se prosím znovu připojte.",
  "addons.reconnect": "Znovu připojit",
  "addons.socialConnectionsIntro": "Propojte své sociální účty pro rychlé přihlášení. Účty můžete kdykoliv připojit nebo odpojit.",
  "addons.weatherflowAccessToken": "Přístupový token",
  "addons.weatherflowCreateToken": "Vytvořte a získejte svůj token z tohoto odkazu",
  "addons.weatherflowTempestDescription": "Meteorologický systém Tempest s vestavěným větroměrem a srážkoměrem",
  "addons.weatherServices": "Meteorologické služby",
  "addons.weatherServicesConnected": "{count, plural, =0 {Žádné připojené služby} one {# připojená služba} few {# připojené služby} many {# připojené služby} other {# připojených služeb}}",
  "addons.weatherServicesDescription": "Připojte Netatmo, Davis, Weatherflow a další",
  "addons.wundergroundApiKey": "API klíč",
  "addons.wundergroundDescription": "Weather Underground je globální komunita lidí, kteří propojují data z environmentálních senzorů, jako jsou meteorologické stanice a monitory kvality ovzduší, abychom vám mohli dodat bohatá, hyperlokální data, která potřebujete k podpoře vašich vášní.",
  "addons.wundergroundRemoveStationDescription": "Stanice bude odebrána z vašeho účtu SmartMixin. Pokud ji nepřidal i jiný účet SmartMixin, stanice i historie, kterou pro ni SmartMixin zaznamenal, budou smazány. Na Weather Underground se nic nezmění.",
  "addons.wundergroundRemoveStationTitle": "Smazat {station}?",
  "addons.wundergroundRetrieveApiKey": "Získejte svůj API klíč z tohoto odkazu",
  "addons.wundergroundStationId": "ID stanice",
  "airQuality.adviceActivityGood": "Ideální den na pohyb venku",
  "airQuality.adviceActivityHazardous": "Vyhněte se veškeré fyzické aktivitě venku",
  "airQuality.adviceActivityLabel": "Fyzická aktivita",
  "airQuality.adviceActivityModerate": "Dobrý den na pohyb venku",
  "airQuality.adviceActivitySensitive": "Zvažte kratší a méně náročné aktivity venku",
  "airQuality.adviceActivityUnhealthy": "Omezte dlouhé nebo náročné aktivity a dělejte více přestávek",
  "airQuality.adviceActivityVeryUnhealthy": "Vyhněte se dlouhým nebo náročným aktivitám; zvažte přesun dovnitř",
  "airQuality.adviceGroupsGood": "Nejsou nutná žádná zvláštní opatření",
  "airQuality.adviceGroupsHazardous": "Zůstaňte uvnitř a omezte aktivitu",
  "airQuality.adviceGroupsLabel": "Citlivé skupiny",
  "airQuality.adviceGroupsModerate": "Neobvykle citliví lidé: kratší a méně náročné aktivity",
  "airQuality.adviceGroupsSensitive": "Kratší a méně náročné aktivity venku a více přestávek",
  "airQuality.adviceGroupsUnhealthy": "Vyhněte se dlouhým nebo náročným aktivitám venku; zvažte přesun dovnitř",
  "airQuality.adviceGroupsVeryUnhealthy": "Vyhněte se veškeré fyzické aktivitě venku; odložte ji nebo přesuňte dovnitř",
  "airQuality.adviceTimingLabel": "Kdy jít ven",
  "airQuality.adviceTimingMorning": "Nejlépe dopoledne — ozón je tehdy nižší",
  "airQuality.airQuality": "Kvalita ovzduší",
  "airQuality.airQualityIndex": "Index kvality ovzduší",
  "airQuality.aqiForecast": "Předpověď kvality ovzduší",
  "airQuality.co2Fresh": "Čerstvý",
  "airQuality.co2GettingStale": "Mírně vydýchaný",
  "airQuality.co2Stale": "Vydýchaný",
  "airQuality.dailyForecast": "Denní předpověď",
  "airQuality.dominantPollutant": "Převažující znečišťující látka",
  "airQuality.expectedPeak": "Očekávaný vrchol",
  "airQuality.good": "Dobrá",
  "airQuality.goodDescription": "Kvalita ovzduší je považována za uspokojivou a znečištění ovzduší představuje malé nebo žádné riziko.",
  "airQuality.hazardous": "Nebezpečná",
  "airQuality.hazardousDescription": "Zdravotní upozornění: Kdokoli může zaznamenat závažnější zdravotní účinky.",
  "airQuality.indoorAirQuality": "Kvalita vnitřního vzduchu",
  "airQuality.moderate": "Průměrná",
  "airQuality.moderateDescription": "Kvalita vzduchu je přijatelná. U některých znečišťujících látek však může existovat zdravotní riziko pro velmi malý počet lidí neobvykle citlivých na znečištění ovzduší.",
  "airQuality.noForecastForLocation": "Pro toto místo není k dispozici předpověď kvality ovzduší.",
  "airQuality.now": "Nyní",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Znečišťující látky",
  "airQuality.recommendations": "Doporučení",
  "airQuality.sensitiveUnhealthy": "Nezdravá pro citlivé skupiny",
  "airQuality.sensitiveUnhealthyDescription": "Členové citlivých skupin mohou pocítit zdravotní potíže. Běžná populace pravděpodobně nebude ovlivněna.",
  "airQuality.subIndex": "Dílčí index AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Porozumět indexu",
  "airQuality.unhealthy": "Nezdravá",
  "airQuality.unhealthyDescription": "Každý může začít pociťovat účinky na zdraví; členové vnímavých skupin mohou pociťovat závažnější zdravotní účinky.",
  "airQuality.veryUnhealthy": "Velmi nezdravá",
  "airQuality.veryUnhealthyDescription": "Zdravotní varování před nouzovými podmínkami. Je pravděpodobnější, že bude postižena celá populace.",
  "alerts.addAlert": "Přidat upozornění",
  "alerts.addCondition": "Přidat podmínku",
  "alerts.alertAdded": "Upozornění bylo úspěšně přidáno",
  "alerts.alertAuthorizationNotice": "Upozornění mohou fungovat, pouze pokud povolíte SmartMixin zobrazovat upozornění",
  "alerts.alertDeleted": "Upozornění bylo úspěšně smazáno",
  "alerts.alertName": "Název upozornění",
  "alerts.alertWhen": "Chci být upozorněn, když:",
  "alerts.aqiGreaterThan": "AQI větší než",
  "alerts.aqiGreaterThanThreshold": "AQI nad prahovou hodnotou {value}{unit}",
  "alerts.aqiLessThan": "AQI méně než",
  "alerts.aqiLessThanThreshold": "AQI pod prahovou hodnotou {value}{unit}",
  "alerts.atLeastOneCondition": "Musíte přidat alespoň jednu podmínku",
  "alerts.co2GreaterThan": "CO2 větší než",
  "alerts.co2GreaterThanThreshold": "CO2 nad prahovou hodnotou {value}{unit}",
  "alerts.co2LessThan": "CO2 méně než",
  "alerts.co2LessThanThreshold": "CO2 pod prahovou hodnotou {value}{unit}",
  "alerts.conditions": "Podmínky",
  "alerts.conditionsDroppedOnStationChange": "Tato stanice nepodporuje, odebráno: {conditions}",
  "alerts.createAlert": "Vytvořit upozornění",
  "alerts.dailyPrecipitationGreaterThan": "Denní srážky větší než",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Denní srážky nad prahem {value}{unit}",
  "alerts.deleteAlert": "Smazat upozornění",
  "alerts.editAlert": "Upravit upozornění",
  "alerts.editCondition": "Změnit podmínku",
  "alerts.gustSpeedGreaterThan": "Poryv větší než",
  "alerts.gustSpeedGreaterThanThreshold": "Poryv nad prahovou hodnotou {value}{unit}",
  "alerts.gustSpeedLessThan": "Poryv méně než",
  "alerts.gustSpeedLessThanThreshold": "Poryv pod prahovou hodnotou {value}{unit}",
  "alerts.heatIndexGreaterThan": "Tepelný index více než",
  "alerts.heatIndexGreaterThanThreshold": "Tepelný index nad prahovou hodnotou {value}{unit}",
  "alerts.heatIndexLessThan": "Tepelný index méně než",
  "alerts.heatIndexLessThanThreshold": "Tepelný index pod prahovou hodnotou {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex více než",
  "alerts.humidexGreaterThanThreshold": "Humidex nad prahovou hodnotou {value}{unit}",
  "alerts.humidexLessThan": "Humidex méně než",
  "alerts.humidexLessThanThreshold": "Humidex pod prahovou hodnotou {value}{unit}",
  "alerts.humidityGreaterThan": "Vlhkost vyšší než",
  "alerts.humidityGreaterThanThreshold": "Vlhkost nad prahovou hodnotou {value}{unit}",
  "alerts.humidityLessThan": "Vlhkost nižší než",
  "alerts.humidityLessThanThreshold": "Vlhkost pod prahovou hodnotou {value}{unit}",
  "alerts.inProgress": "Probíhá",
  "alerts.leafWetnessGreaterThan": "Vlhkost listů vyšší než",
  "alerts.leafWetnessGreaterThanThreshold": "Vlhkost listů nad prahovou hodnotou {value}{unit}",
  "alerts.leafWetnessLessThan": "Vlhkost listů nižší než",
  "alerts.leafWetnessLessThanThreshold": "Vlhkost listů pod prahovou hodnotou {value}{unit}",
  "alerts.myAlerts": "Moje upozornění",
  "alerts.noConfiguredAlert": "Ještě nemáte upozornění, přidejte ho",
  "alerts.noiseGreaterThan": "Hluk větší než",
  "alerts.noiseGreaterThanThreshold": "Hluk nad prahovou hodnotou {value}{unit}",
  "alerts.noiseLessThan": "Hluk menší než",
  "alerts.noiseLessThanThreshold": "Hluk pod prahovou hodnotou {value}{unit}",
  "alerts.noteOnConditions": "Upozornění se spustí, když jsou ověřeny všechny níže uvedené podmínky",
  "alerts.noTriggerHistory": "Toto upozornění zatím nebylo spuštěno.",
  "alerts.pm10GreaterThan": "PM 10 větší než",
  "alerts.pm10GreaterThanThreshold": "PM 10 nad prahovou hodnotou {value}{unit}",
  "alerts.pm10LessThan": "PM 10 méně než",
  "alerts.pm10LessThanThreshold": "PM 10 pod prahovou hodnotou {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 větší než",
  "alerts.pm1GreaterThanThreshold": "PM 1 nad prahovou hodnotou {value}{unit}",
  "alerts.pm1LessThan": "PM 1 méně než",
  "alerts.pm1LessThanThreshold": "PM 1 pod prahovou hodnotou {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 větší než",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 nad prahovou hodnotou {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 méně než",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 pod prahovou hodnotou {value}{unit}",
  "alerts.postStormSummary": "Souhrn po dešti",
  "alerts.postStormSynopsisHelper": "Po skončení každého deště obdržíte souhrnné oznámení.",
  "alerts.postStormSynopsisSoleCondition": "Souhrn po dešti nelze kombinovat s jinými podmínkami.",
  "alerts.precipitationGreaterThan": "Hodinové srážky větší než",
  "alerts.precipitationGreaterThanThreshold": "Hodinové srážky nad prahem {value}{unit}",
  "alerts.pressureGreaterThan": "Tlak větší než",
  "alerts.pressureGreaterThanThreshold": "Tlak nad prahovou hodnotou {value}{unit}",
  "alerts.pressureLessThan": "Tlak menší než",
  "alerts.pressureLessThanThreshold": "Tlak pod prahovou hodnotou {value}{unit}",
  "alerts.rainRateGreaterThan": "Intenzita deště větší než",
  "alerts.rainRateGreaterThanThreshold": "Intenzita deště nad prahem {value}{unit}",
  "alerts.sensorNotReporting": "Tento senzor momentálně neposílá data. Upozornění se obnoví, jakmile je začne znovu posílat.",
  "alerts.soilMoistureGreaterThan": "Půdní vlhkost vyšší než",
  "alerts.soilMoistureGreaterThanThreshold": "Půdní vlhkost nad prahovou hodnotou {value}{unit}",
  "alerts.soilMoistureLessThan": "Půdní vlhkost nižší než",
  "alerts.soilMoistureLessThanThreshold": "Půdní vlhkost pod prahovou hodnotou {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Sluneční záření větší než",
  "alerts.solarRadiationGreaterThanThreshold": "Sluneční záření nad prahovou hodnotou {value}{unit}",
  "alerts.solarRadiationLessThan": "Sluneční záření méně než",
  "alerts.solarRadiationLessThanThreshold": "Sluneční záření pod prahovou hodnotou {value}{unit}",
  "alerts.stationNoLongerReports": "Tato stanice už neposílá data, takže se toto upozornění nemůže spustit.",
  "alerts.stormChartUnavailable": "Historie srážek pro tento déšť není k dispozici.",
  "alerts.stormDetail": "Souhrn deště",
  "alerts.stormDuration": "Doba trvání",
  "alerts.stormEnd": "Konec",
  "alerts.stormPeakRate": "Maximální intenzita deště",
  "alerts.stormStart": "Začátek",
  "alerts.stormTotal": "Celkové srážky",
  "alerts.temperatureGreaterThan": "Teplota vyšší než",
  "alerts.temperatureGreaterThanThreshold": "Teplota nad prahovou hodnotou {value}{unit}",
  "alerts.temperatureLessThan": "Teplota nižší než",
  "alerts.temperatureLessThanThreshold": "Teplota pod prahovou hodnotou {value}{unit}",
  "alerts.thresholdOutOfRange": "Musí být mezi {min} a {max}",
  "alerts.thswGreaterThan": "THSW více než",
  "alerts.thswGreaterThanThreshold": "THSW nad prahovou hodnotou {value}{unit}",
  "alerts.thswLessThan": "THSW méně než",
  "alerts.thswLessThanThreshold": "THSW pod prahovou hodnotou {value}{unit}",
  "alerts.thwGreaterThan": "THW více než",
  "alerts.thwGreaterThanThreshold": "THW nad prahovou hodnotou {value}{unit}",
  "alerts.thwLessThan": "THW méně než",
  "alerts.thwLessThanThreshold": "THW pod prahovou hodnotou {value}{unit}",
  "alerts.triggerHistory": "Historie upozornění",
  "alerts.uvGreaterThan": "UV větší než",
  "alerts.uvGreaterThanThreshold": "UV nad prahovou hodnotou {value}{unit}",
  "alerts.uvLessThan": "UV nižší než",
  "alerts.uvLessThanThreshold": "UV pod prahovou hodnotou {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Viditelnost nad prahovou hodnotou {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Viditelnost pod prahovou hodnotou {value}{unit}",
  "alerts.visiblityGreaterThan": "Viditelnost větší než",
  "alerts.visiblityLessThan": "Viditelnost menší než",
  "alerts.whichMeasure": "Na kterou měřenou veličinu chcete být upozorněni?",
  "alerts.whichModule": "Na který modul byste chtěli být upozorněni?",
  "alerts.whichSensor": "Na který senzor byste chtěli být upozorněni?",
  "alerts.windChillGreaterThan": "Wind Chill více než",
  "alerts.windChillGreaterThanThreshold": "Wind Chill nad prahovou hodnotou {value}{unit}",
  "alerts.windChillLessThan": "Wind Chill méně než",
  "alerts.windChillLessThanThreshold": "Wind Chill pod prahovou hodnotou {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vítr větší než",
  "alerts.windSpeedGreaterThanThreshold": "Vítr nad prahovou hodnotou {value}{unit}",
  "alerts.windSpeedLessThan": "Vítr méně než",
  "alerts.windSpeedLessThanThreshold": "Vítr pod prahovou hodnotou {value}{unit}",
  "appUpdate.updateAvailable": "Je k dispozici aktualizace",
  "appUpdate.updateAvailableOpenAppStore": "Klepnutím otevřete App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Klepnutím otevřete Google Play",
  "appUpdate.updateAvailableVersion": "Je k dispozici aktualizace: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Je vyžadována aktualizace vaší aplikace, upgradujte v Google Play.",
  "appUpdate.upgradeRequiredIos": "Je vyžadována aktualizace vaší aplikace, upgradujte v App Store.",
  "astral.aboveHorizonAllDay": "Celý den nad obzorem",
  "astral.aboveTheHorizon": "nad obzorem",
  "astral.apparentSize": "Úhlová velikost",
  "astral.apparentSizeAcross": "o průměru {size}",
  "astral.astronomicalDawn": "Astronomický úsvit",
  "astral.astronomicalDusk": "Astronomický soumrak",
  "astral.belowHorizonAllDay": "Celý den pod obzorem",
  "astral.belowHorizonSince": "Pod obzorem od {time}",
  "astral.belowHorizonSinceOn": "Pod obzorem od {day} {time}",
  "astral.brightAllNight": "Světlá obloha celou noc — nikdy úplná tma",
  "astral.brightestMoment": "Nejsvětlejší okamžik",
  "astral.civilDawn": "Občanský úsvit",
  "astral.civilDusk": "Občanský soumrak",
  "astral.darkSkyBetween": "Tmavá obloha {from} → {to}",
  "astral.darkSkyWindow": "Tmavá obloha {from} → {to} · {duration} bez Měsíce",
  "astral.dayLength": "Délka dne",
  "astral.daylightThroughTheYear": "Délka dne v průběhu roku",
  "astral.dayOfCycle": "den {day} z {total}",
  "astral.doesNotOccurToday": "Dnes nenastává",
  "astral.domeHint": "Tažením projděte nocí",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Nejdřívější východ slunce",
  "astral.earliestSunset": "Nejdřívější západ slunce",
  "astral.equinox": "Rovnodennost",
  "astral.equinoxIn": "Rovnodennost za {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "astral.evening": "Večer",
  "astral.exactPhaseAt": "Přesně v {time}",
  "astral.firstQuarter": "První čtvrť",
  "astral.firstSunriseIn": "První východ slunce za {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "astral.firstSunsetIn": "První západ slunce za {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "astral.fullMoon": "Úplněk",
  "astral.goldenHourBegins": "Začátek zlaté hodiny",
  "astral.goldenHourEnds": "Konec zlaté hodiny",
  "astral.highestPoint": "Nejvyšší bod",
  "astral.inDays": "za {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "astral.lastQuarter": "Poslední čtvrť",
  "astral.latestSunrise": "Nejpozdější východ slunce",
  "astral.latestSunset": "Nejpozdější západ slunce",
  "astral.litShort": "Osvětl.",
  "astral.longestDay": "Nejdelší den",
  "astral.lowestPoint": "Nejnižší bod",
  "astral.maxAltitudeShort": "Max",
  "astral.midday": "Poledne",
  "astral.midnightSun": "Půlnoční slunce",
  "astral.midnightSunPeriod": "Půlnoční slunce",
  "astral.milestoneFootnotePolar": "Slunce zde {days, plural, one {# den} few {# dny} other {# dní}} v roce nevychází ani nezapadá, a tak seznam místo obvyklých extrémů východu a západu ukazuje, kdy k tomu dochází.",
  "astral.milestoneFootnoteTemperate": "Nejčasnější západ a nejpozdější východ nepřipadají na nejkratší den — tato dvě data určuje časová rovnice, nikoli slunovrat.",
  "astral.moon": "Měsíc",
  "astral.moonAltitude": "Výška",
  "astral.moonDirection": "Azimut",
  "astral.moonDistance": "Vzdálenost",
  "astral.moonlessFor": "{duration} bez Měsíce",
  "astral.moonPhases": "Fáze Měsíce",
  "astral.moonrise": "Východ Měsíce",
  "astral.moonset": "Západ Měsíce",
  "astral.moonUpAllNight": "Měsíc je nad obzorem celou noc",
  "astral.moonWashesOutNight": "Měsíc je nad obzorem od {rise} do {set} a prosvětluje celou noc",
  "astral.morning": "Ráno",
  "astral.nauticalDawn": "Nautický úsvit",
  "astral.nauticalDusk": "Nautický soumrak",
  "astral.newMoon": "Nov",
  "astral.nextDay": "+1 den",
  "astral.nextProperlyDarkNight": "Příští opravdu tmavá noc",
  "astral.nextRise": "příští východ v {time}",
  "astral.nextRiseOn": "příští východ {day} v {time}",
  "astral.nextSevenNights": "Příštích sedm nocí",
  "astral.nightDate": "Datum",
  "astral.noAstronomicalDarknessTonight": "Dnes v noci žádná astronomická tma",
  "astral.noDarkNightAhead": "Žádná v příštích dvou týdnech",
  "astral.noStationLocation": "Neznámá poloha",
  "astral.noStationLocationDescription": "Tato stanice nemá uloženou polohu, takže pro ni nelze vypočítat slunce a měsíc.",
  "astral.noSunriseToday": "Dnes slunce nevychází",
  "astral.nowAtBearing": "nyní {altitude} · azimut {direction}",
  "astral.observing": "Pozorování",
  "astral.ofDaylightLeft": "denního světla zbývá",
  "astral.overTheNextThreeWeeks": "během příštích 3 týdnů",
  "astral.percentLit": "osvětlení {percent}",
  "astral.polarNight": "Polární noc",
  "astral.polarNightPeriod": "Polární noc",
  "astral.rightNow": "Právě teď",
  "astral.riseShort": "Východ",
  "astral.setShort": "Západ",
  "astral.shortestDay": "Nejkratší den",
  "astral.solarNoon": "Pravé poledne",
  "astral.solstice": "Slunovrat",
  "astral.sunBelowHorizon": "Slunce {degrees}° pod obzorem",
  "astral.sunEvents": "Sluneční události",
  "astral.sunNeverDarkEnough": "Slunce nikdy neklesne 18° pod obzor",
  "astral.sunNeverSets": "Slunce nezapadá",
  "astral.sunrise": "Východ slunce",
  "astral.sunriseAndSunset": "Východ a západ slunce",
  "astral.sunriseAt": "Východ slunce v {time}",
  "astral.sunset": "Západ slunce",
  "astral.sunsetAt": "Západ slunce v {time}",
  "astral.thisYearAtNorth": "Letos na {degrees}° s. š.",
  "astral.thisYearAtSouth": "Letos na {degrees}° j. š.",
  "astral.tonight": "Dnes v noci",
  "astral.twilightAllNight": "Soumrak celou noc — nikdy úplná tma",
  "astral.upFor": "{duration} nad obzorem",
  "astral.usableLight": "Využitelné světlo",
  "astral.vsAverage": "{percent} oproti průměru",
  "astral.vsYesterday": "oproti včerejšku",
  "astral.waningCrescent": "Ubývající srpek",
  "astral.waningGibbous": "Ubývající vypouklý měsíc",
  "astral.waxingCrescent": "Dorůstající srpek",
  "astral.waxingGibbous": "Dorůstající vypouklý měsíc",
  "astral.whereToLook": "Kam se dívat",
  "astral.withoutTheMoon": "{duration} bez Měsíce",
  "auth.alreadyHaveAccount": "Už máte účet?",
  "auth.authContainerTagline": "Váš osobní panel počasí. Připojte své stanice a získejte data v reálném čase na dosah ruky.",
  "auth.backToLogin": "Zpět na přihlášení",
  "auth.checkYourEmail": "Zkontrolujte svůj e-mail",
  "auth.continueWithApple": "Pokračovat přes Apple",
  "auth.continueWithFacebook": "Pokračovat přes Facebook",
  "auth.continueWithGoogle": "Pokračovat přes Google",
  "auth.email": "E-mailová adresa",
  "auth.emailRequiredLoginFacebook": "Emailová adresa je vyžadována při přihlášení pomocí Facebooku",
  "auth.emailVerification": "Potvrzení e-mailu",
  "auth.emailVerificationFailure": "Při ověřování vašeho e-mailu došlo k problému.",
  "auth.emailVerificationSuccess": "Váš email byl úspěšně ověřen.",
  "auth.firstName": "Jméno",
  "auth.forgotPassword": "Zapomenuté heslo",
  "auth.forgotPasswordSubtitle": "Zadejte svůj e-mail a my vám zašleme odkaz pro resetování hesla.",
  "auth.lastName": "Příjmení",
  "auth.login": "Přihlásit se",
  "auth.loginSubtitle": "Vítejte zpět! Zadejte prosím své údaje.",
  "auth.loginToSmartMixinDescription": "Přihlaste se do SmartMixin a získejte přístup ke svým meteorologickým stanicím, analýzám a osobnímu panelu počasí.",
  "auth.logout": "Odhlásit se",
  "auth.logoutConfirmation": "Chcete se odhlásit?",
  "auth.noAccountYet": "Ještě nemáte účet?",
  "auth.or": "nebo",
  "auth.password": "Heslo",
  "auth.passwordReset": "Resetovat heslo",
  "auth.passwordResetSuccess": "Vaše heslo bylo úspěšně změněno.",
  "auth.register": "Registrovat",
  "auth.registerDescription": "Vytvořte si bezplatný účet SmartMixin pro připojení vašich meteorologických stanic, sledování dat o počasí a přístup k výkonným analytickým nástrojům.",
  "auth.registerSubtitle": "Vytvořte si účet a začněte.",
  "auth.restorePassword": "Obnovit heslo",
  "auth.restorePasswordSuccess": "Právě jsme vám zaslali odkaz pro resetování hesla na {emailAddress} s dalšími pokyny.",
  "auth.sendReset": "Odeslat pokyny k resetování",
  "auth.signInWithApple": "Přihlásit se přes Apple",
  "auth.socialAccount": "nebo použijte svůj účet",
  "auth.staffVerificationCode": "Ověřovací kód",
  "auth.staffVerificationExpiresIn": "Ověřeno. Platnost vyprší za {duration}.",
  "auth.staffVerificationInvalidCode": "Nesprávný kód. Zkuste to znovu.",
  "auth.staffVerificationLoginAsStopped": "Login As byl ukončen: pro pokračování zadejte ověřovací kód na obrazovce Debug.",
  "auth.staffVerificationNotEnrolled": "Pro váš účet není nastavena žádná ověřovací aplikace. Přidejte ji v nastavení zabezpečení v administraci.",
  "auth.staffVerificationPrompt": "Zadejte 6místný kód z ověřovací aplikace nebo kód pro obnovení, abyste mohli používat Login As a vyhledávání uživatelů.",
  "auth.staffVerificationSetupLink": "Přidat ověřovací aplikaci",
  "auth.staffVerificationSubmit": "Ověřit",
  "auth.staffVerificationTitle": "Ověření personálu",
  "calendar.afternoon": "Odpoledne",
  "calendar.april": "Duben",
  "calendar.august": "Srpen",
  "calendar.changePeriod": "Období: {period}. Změnit období",
  "calendar.currentDay": "Dnes",
  "calendar.dateFormat": "Formát data",
  "calendar.day": "Den",
  "calendar.december": "Prosinec",
  "calendar.durationHours": "{hours} h",
  "calendar.durationHoursMinutes": "{hours} h {minutes} min",
  "calendar.durationMinutes": "{minutes} min",
  "calendar.durationMinutesSeconds": "{minutes} min {seconds} s",
  "calendar.durationSeconds": "{seconds} s",
  "calendar.earlierYears": "Dřívější roky",
  "calendar.endTime": "Konec",
  "calendar.evening": "Večer",
  "calendar.february": "Únor",
  "calendar.goToNextDay": "Následující den",
  "calendar.goToNextMonth": "Následující měsíc",
  "calendar.goToNextWeek": "Následující týden",
  "calendar.goToNextYear": "Následující rok",
  "calendar.goToPreviousDay": "Předchozí den",
  "calendar.goToPreviousMonth": "Předchozí měsíc",
  "calendar.goToPreviousWeek": "Předchozí týden",
  "calendar.goToPreviousYear": "Předchozí rok",
  "calendar.hour": "Hodina",
  "calendar.hoursCount": "{count, plural, one {# hodina} few {# hodiny} many {# hodiny} other {# hodin}}",
  "calendar.hoursShort": "h",
  "calendar.hoursShortCount": "{count, plural, one {# h} few {# h} many {# h} other {# h}}",
  "calendar.january": "Leden",
  "calendar.july": "Červenec",
  "calendar.june": "Červen",
  "calendar.last12Hours": "Posledních 12 hodin",
  "calendar.last24Hours": "Posledních 24 hodin",
  "calendar.last30Days": "Posledních 30 dní",
  "calendar.last3Hours": "Poslední 3 hodiny",
  "calendar.last6Hours": "Posledních 6 hodin",
  "calendar.last7Days": "Posledních 7 dní",
  "calendar.lastHour": "Poslední hodina",
  "calendar.laterYears": "Pozdější roky",
  "calendar.march": "Březen",
  "calendar.max": "Max",
  "calendar.may": "Květen",
  "calendar.month": "Měsíc",
  "calendar.monthTotal": "Tento měsíc",
  "calendar.morning": "Ráno",
  "calendar.nextHours": "Další hodiny",
  "calendar.night": "Noc",
  "calendar.november": "Listopad",
  "calendar.october": "Říjen",
  "calendar.oneDay": "1 den",
  "calendar.oneHour": "1 hodina",
  "calendar.oneMonth": "1 měsíc",
  "calendar.oneWeek": "1 týden",
  "calendar.periodRangeSpoken": "{start} až {end}",
  "calendar.previous24Hours": "Předchozích 24 hodin",
  "calendar.previous30Days": "Předchozích 30 dní",
  "calendar.previous7Days": "Předchozích 7 dní",
  "calendar.previousDay": "Předchozím dnem",
  "calendar.previousHours": "Předchozí hodiny",
  "calendar.previousMonth": "Předchozím měsícem",
  "calendar.previousWeek": "Předchozím týdnem",
  "calendar.previousYear": "Předchozím rokem",
  "calendar.sameDayLastYear": "Stejným dnem minulý rok",
  "calendar.sameMonthLastYear": "Stejným měsícem minulý rok",
  "calendar.selectADate": "Vyberte datum",
  "calendar.selectAggregation": "Vyberte zobrazenou hodnotu",
  "calendar.selectAMonth": "Vyberte měsíc",
  "calendar.selectAYear": "Vyberte rok",
  "calendar.selectGranularity": "Vyberte podrobnost",
  "calendar.selectPeriod": "Vyberte období",
  "calendar.september": "Září",
  "calendar.sixHours": "6 hodin",
  "calendar.startTime": "Začátek",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 hodiny",
  "calendar.timezone": "Časové pásmo",
  "calendar.today": "Dnes",
  "calendar.untilChanged": "Dokud se nezmění",
  "calendar.untilTime": "Do {time}",
  "calendar.untilTodayAt": "Dnes do {time}",
  "calendar.untilTomorrowAt": "Zítra do {time}",
  "calendar.use24HourFormat": "Použít 24hodinový formát",
  "calendar.week": "Týden",
  "calendar.year": "Rok",
  "calendar.yearToDate": "Tento rok",
  "calendar.yesterday": "Včera",
  "charts.averageOverThePeriod": "Průměr za období",
  "charts.calendarView": "Zobrazení kalendáře",
  "charts.charts": "Grafy",
  "charts.chartView": "Zobrazení grafu",
  "charts.comparison": "Srovnání",
  "charts.customizeComparisonMetrics": "Přizpůsobit metriky srovnání",
  "charts.customizeComparisonMetricsDescription": "Přetáhněte položky pro změnu pořadí metrik srovnání. Klepněte na ikonu oka pro zobrazení nebo skrytí metrik.",
  "charts.loading": "Načítání grafu",
  "charts.maxOverThePeriod": "Maximum za období",
  "charts.measureToDisplay": "Zobrazovaná veličina",
  "charts.minMaxRange": "Min. / Max.",
  "charts.noDataForThisPeriod": "Pro toto období nejsou dostupná data",
  "charts.observations": "Pozorování",
  "charts.observedTemperature": "Naměřená teplota",
  "charts.seriesTableDate": "Datum",
  "charts.showComparison": "Zobrazit srovnání",
  "charts.stationComparison": "Srovnání stanic",
  "charts.stationComparisonDescription": "Umožňuje porovnat historické údaje o počasí s údaji jiné stanice.",
  "charts.sumOverThePeriod": "Kumulované za období",
  "charts.tableLabel": "Tabulka: {chart}",
  "charts.toggleSeries": "Zobrazit nebo skrýt {series}",
  "charts.viewAsChart": "Graf",
  "charts.viewAsList": "Seznam",
  "charts.viewAsPeriods": "Části dne",
  "charts.viewAsTable": "Tabulka",
  "charts.viewLabel": "Zobrazení: {chart}",
  "common.add": "Přidat",
  "common.altitude": "Nadmořská výška",
  "common.analysis": "Analýza",
  "common.average": "Průměr",
  "common.back": "Zpět",
  "common.backToHome": "Zpět na hlavní stránku",
  "common.cancel": "Zrušit",
  "common.cannotBeEmpty": "Toto pole nemůže být prázdné.",
  "common.close": "Zavřít",
  "common.dailyForecast": "Denní předpověď",
  "common.default": "Výchozí",
  "common.delete": "Vymazat",
  "common.details": "Detaily",
  "common.edit": "Upravit",
  "common.exitFullscreen": "Ukončit celou obrazovku",
  "common.forecast": "Předpověď",
  "common.frequency": "Frekvence",
  "common.full": "Plný",
  "common.fullscreen": "Celá obrazovka",
  "common.help": "Nápověda",
  "common.hidden": "Skryté",
  "common.high": "Vysoký",
  "common.iDontKnowYet": "Ještě nevím",
  "common.indoor": "Uvnitř",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Poslední aktualizace",
  "common.low": "Nízký",
  "common.maximum": "Maximum",
  "common.medium": "Střední",
  "common.minimum": "Minimum",
  "common.more": "Více",
  "common.moreInformation": "Více informací",
  "common.next": "Další",
  "common.no": "Ne",
  "common.noAccountNeeded": "Bez nutnosti účtu",
  "common.noItemsAvailable": "Nejsou k dispozici žádné položky",
  "common.notNow": "Ne teď",
  "common.now": "Nyní",
  "common.openSettings": "Otevřít nastavení",
  "common.outdoor": "Venku",
  "common.pageNotFound": "Stránka nenalezena",
  "common.pageNotFoundDescription": "Stránka, kterou hledáte, neexistuje nebo byla přesunuta.",
  "common.rain": "Srážky",
  "common.reorderCancel": "Přesun zrušen: {item}. Zpět na pozici {position} z {count}.",
  "common.reorderEnd": "Umístěno: {item}. Pozice {position} z {count}.",
  "common.reorderInstructions": "Chcete-li tuto položku přesunout, stiskněte mezerník nebo Enter, šipkami nahoru a dolů vyberte její místo a znovu stiskněte mezerník nebo Enter pro umístění, nebo Escape pro zrušení.",
  "common.reorderOver": "{item} – nyní na pozici {position} z {count}.",
  "common.reorderStart": "Zvednuto: {item}. Pozice {position} z {count}.",
  "common.share": "Sdílet",
  "common.shareImageFailed": "Obrázek se nepodařilo sdílet",
  "common.shareYourWeather": "Podělte se o své počasí",
  "common.skip": "Přeskočit",
  "common.start": "Start",
  "common.unknown": "Neznámý",
  "common.validate": "Potvrdit",
  "common.validEmail": "Je vyžadována platná e-mailová adresa.",
  "common.very_low": "Velmi nízký",
  "common.weatherObservations": "Pozorování počasí",
  "common.welcome": "Vítejte v SmartMixin!",
  "common.wind": "Vítr",
  "common.yes": "Ano",
  "common.zoomImage": "Přiblížit obrázek",
  "compass.E": "V",
  "compass.E_long": "Východ",
  "compass.ENE": "VSV",
  "compass.ENE_long": "Východoseverovýchod",
  "compass.ESE": "VJV",
  "compass.ESE_long": "Východojihovýchod",
  "compass.N": "S",
  "compass.N_long": "Sever",
  "compass.NE": "SV",
  "compass.NE_long": "Severovýchod",
  "compass.NNE": "SSV",
  "compass.NNE_long": "Severoseverovýchod",
  "compass.NNW": "SSZ",
  "compass.NNW_long": "Severoseverozápad",
  "compass.NW": "SZ",
  "compass.NW_long": "Severozápad",
  "compass.S": "J",
  "compass.S_long": "Jih",
  "compass.SE": "JV",
  "compass.SE_long": "Jihovýchod",
  "compass.SSE": "JJV",
  "compass.SSE_long": "Jihojihovýchod",
  "compass.SSW": "JJZ",
  "compass.SSW_long": "Jihojihozápad",
  "compass.SW": "JZ",
  "compass.SW_long": "Jihozápad",
  "compass.W": "Z",
  "compass.W_long": "Západ",
  "compass.WNW": "ZSZ",
  "compass.WNW_long": "Západoseverozápad",
  "compass.WSW": "ZJZ",
  "compass.WSW_long": "Západojihozápad",
  "dashboard.currentObservations": "Aktuální pozorování",
  "dashboard.currentRainEvent": "Aktuální déšť",
  "dashboard.currentWeatherConditions": "Aktuální počasí",
  "dashboard.customizeDashboard": "Přizpůsobit",
  "dashboard.customizeDashboardDescription": "Přetáhněte položky pro změnu pořadí na nástěnce. Klepněte na ikonu oka pro zobrazení nebo skrytí sekcí.",
  "dashboard.dashboard": "Panel",
  "dashboard.dayRangeExpected": "{value} očekáváno v {time}",
  "dashboard.dayRangeReached": "{value} v {time}",
  "dashboard.dayRangeSteady": "Stabilně {value} celý den",
  "dashboard.hiddenSensors": "Skryté senzory",
  "dashboard.hideSensor": "Skrýt {sensor}",
  "dashboard.lastRainEvent": "Poslední déšť",
  "dashboard.lastVisibleSensor": "Alespoň jeden senzor musí zůstat viditelný.",
  "dashboard.manageSensors": "Správa senzorů",
  "dashboard.manageSensorsDescription": "Přetáhněte položky pro změnu pořadí senzorů. Klepněte na ikonu oka pro zobrazení nebo skrytí senzorů. Klepněte na název pro jeho přejmenování.",
  "dashboard.manageSensorsDescriptionWeb": "Kliknutím na tužku senzor přejmenujete, přetažením za úchyt změníte pořadí v seznamu a kliknutím na oko ho skryjete nebo zobrazíte.",
  "dashboard.moveSensor": "Přesunout {sensor}",
  "dashboard.pressureSummary": "Souhrn tlaku",
  "dashboard.rainEvents": "Dešťové události",
  "dashboard.rainSummary": "Souhrn srážek",
  "dashboard.renameSensor": "Přejmenovat {sensor}",
  "dashboard.shareOutdoorMeasures": "Sdílet mé venkovní měření",
  "dashboard.shareOutdoorMeasuresDescription": "Zapojte se do komunity SmartMixin sdílením svých externích dat. Data vnitřního modulu nebudou nikdy sdílena.",
  "dashboard.showSensor": "Zobrazit {sensor}",
  "dashboard.temperatureSummary": "Souhrn teploty",
  "dashboard.useDefaultSensorName": "Použít výchozí název",
  "dashboard.windSummary": "Souhrn větru",
  "devices.batteryLevel": "Stav baterie",
  "devices.firmwareVersion": "Verze firmwaru",
  "devices.moduleCount": "{count, plural, one {# modul} few {# moduly} many {# modulu} other {# modulů}}",
  "devices.moduleType": "Typ modulu",
  "devices.noNetatmoWeatherStationYet": "Prozatím nevlastníte meteostanici Netatmo.",
  "devices.noOutdoorModule": "Pro tuto stanici neexistuje funkční venkovní modul.",
  "devices.notReachable": "Nedostupné",
  "devices.serialNumber": "Sériové číslo",
  "devices.signalAverage": "Střední",
  "devices.signalBad": "Slabý",
  "devices.signalGood": "Dobrý",
  "devices.signalStrength": "Síla signálu",
  "devices.signalUnknown": "Neznámý",
  "devices.visitNetatmoWebsite": "Navštivte webové stránky Netatmo",
  "devices.wifiStrength": "Síla Wi-Fi",
  "forecastMaps.addColor": "Přidat barvu",
  "forecastMaps.addLayer": "Přidat vrstvu",
  "forecastMaps.autoDescription": "Nejlepší dostupný pro tento pohled",
  "forecastMaps.autoDescriptionFree": "Bezplatné účty používají {model}",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.autoSwitched": "Nyní {model}: {previous} pokrývá {coverage, number, percent} tohoto pohledu",
  "forecastMaps.backToMaps": "Zpět na mapy",
  "forecastMaps.build": "Vygenerovat",
  "forecastMaps.buildCompleted": "Generování dokončeno",
  "forecastMaps.builderMetaDescription": "Sestavte si vlastní předpovědní mapy z vrstev meteorologických modelů.",
  "forecastMaps.builderTitle": "Tvůrce map",
  "forecastMaps.buildFailed": "Generování se nezdařilo. Zkuste to znovu.",
  "forecastMaps.buildNotPossible": "Tuto mapu zatím nelze vygenerovat — nejsou k dispozici žádná předpovědní data.",
  "forecastMaps.buildProgress": "Vykreslování… {completed}/{total} kroků",
  "forecastMaps.buildStarting": "Spouštění generování…",
  "forecastMaps.byModel": "Podle modelu",
  "forecastMaps.byZone": "Podle zóny",
  "forecastMaps.colormap": "Barevná škála",
  "forecastMaps.colormapCustom": "Vlastní barvy",
  "forecastMaps.colormapGroupDomain": "Meteorologické předvolby",
  "forecastMaps.colormapGroupMatplotlib": "Vědecké předvolby",
  "forecastMaps.colorStop": "Barva {position}",
  "forecastMaps.configUnavailable": "Tato předpovědní mapa není k dispozici. Místo ní se zobrazuje {name}.",
  "forecastMaps.contourLevels": "Úrovně izolinií",
  "forecastMaps.countryCanada": "Kanada",
  "forecastMaps.countryFrance": "Francie",
  "forecastMaps.countryGermany": "Německo",
  "forecastMaps.countryItaly": "Itálie",
  "forecastMaps.countryScandinavia": "Skandinávie",
  "forecastMaps.countrySpain": "Španělsko",
  "forecastMaps.countrySwitzerland": "Švýcarsko",
  "forecastMaps.countryUnitedStates": "Spojené státy",
  "forecastMaps.coverageUnknown": "Oblast neznámá",
  "forecastMaps.coversView": "Pokrývá {coverage, number, percent} tohoto pohledu",
  "forecastMaps.customColormapMinColors": "Vlastní barevná škála vyžaduje alespoň dvě barvy",
  "forecastMaps.customExtent": "Vlastní výřez",
  "forecastMaps.displayName": "Zobrazovaný název",
  "forecastMaps.downscaling": "Faktor ředění větrných praporků",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Nakreslit oblast",
  "forecastMaps.east": "Východ",
  "forecastMaps.extentDrawHint": "Tažením po mapě nakreslete oblast",
  "forecastMaps.extentInvalid": "Západ musí být menší než východ a jih menší než sever",
  "forecastMaps.frameTime": "Čas předpovědi",
  "forecastMaps.height": "Výška (palce)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.inThisArea": "V této oblasti",
  "forecastMaps.invalidHexColor": "Neplatná barva — použijte #RRGGBB",
  "forecastMaps.layerHasErrors": "Tato vrstva obsahuje chyby",
  "forecastMaps.layers": "Vrstvy",
  "forecastMaps.layerTypeBarbs": "Větrné praporky",
  "forecastMaps.layerTypeContour": "Izolinie",
  "forecastMaps.layerTypeFilledContour": "Vyplněné izolinie",
  "forecastMaps.layerTypeMagnitude": "Velikost",
  "forecastMaps.layerTypeRaster": "Rastr",
  "forecastMaps.layerTypeVectorField": "Vektorové pole",
  "forecastMaps.leave": "Odejít",
  "forecastMaps.levelsCount": "Počet",
  "forecastMaps.levelsInvalid": "Neplatné úrovně izolinií",
  "forecastMaps.levelsModeArange": "Pevný krok",
  "forecastMaps.levelsModeExplicit": "Explicitní hodnoty",
  "forecastMaps.levelsModeLinspace": "Rovnoměrně rozložené (počet)",
  "forecastMaps.levelsStep": "Krok",
  "forecastMaps.levelsValues": "Hodnoty",
  "forecastMaps.levelsValuesHint": "Oddělené čárkami, vzestupně",
  "forecastMaps.loadingMaps": "Načítání map…",
  "forecastMaps.localTimeHint": "Zobrazeno v místním čase",
  "forecastMaps.lockedConfig": "{model} je model Premium. Místo něj se zobrazuje {fallback}.",
  "forecastMaps.lockedVariable": "{variable}, Premium",
  "forecastMaps.mapDescription": "Popis",
  "forecastMaps.mapName": "Název mapy",
  "forecastMaps.mapNameRequired": "Zadejte název",
  "forecastMaps.mapSettings": "Nastavení mapy",
  "forecastMaps.maxLayersReached": "Tato mapa dosáhla maxima {max} vrstev.",
  "forecastMaps.maxValue": "Maximální hodnota",
  "forecastMaps.memoryBudgetExceeded": "Rozlišení překračuje limit vykreslování — snižte DPI nebo výšku",
  "forecastMaps.memoryBudgetUsage": "Limit vykreslování: {percent}%",
  "forecastMaps.metaDescription": "Animované předpovědní mapy vytvořené z běhů meteorologických modelů.",
  "forecastMaps.metric": "Veličina",
  "forecastMaps.metricRequired": "Vyberte veličinu",
  "forecastMaps.metricUnavailable": "Pro tento model není k dispozici",
  "forecastMaps.minBelowMax": "Minimum musí být menší než maximum",
  "forecastMaps.minMaxRequired": "Minimální a maximální hodnoty jsou pro tento typ vrstvy povinné",
  "forecastMaps.minValue": "Minimální hodnota",
  "forecastMaps.modelChipAuto": "Auto · {model}",
  "forecastMaps.modelCoversView": "{model} pokrývá {coverage, number, percent} tohoto pohledu",
  "forecastMaps.modelNoRun": "Zatím žádný dokončený běh",
  "forecastMaps.modelOption": "{model}, {grid}",
  "forecastMaps.moveLayerDown": "Posunout dolů",
  "forecastMaps.moveLayerUp": "Posunout nahoru",
  "forecastMaps.nanClipToMin": "Omezit na minimum",
  "forecastMaps.nanMask": "Maskovat",
  "forecastMaps.nanPolicy": "Chybějící data",
  "forecastMaps.nanSkip": "Přeskočit",
  "forecastMaps.noCompletedRun": "Tato mapa zatím nebyla vytvořena. Zkuste to prosím později.",
  "forecastMaps.noLayers": "Zatím žádné vrstvy. Začněte přidáním vrstvy.",
  "forecastMaps.noMapsAvailable": "Zatím nejsou k dispozici žádné předpovědní mapy.",
  "forecastMaps.north": "Sever",
  "forecastMaps.opacity": "Neprůhlednost",
  "forecastMaps.openAsAnimation": "Otevřít jako animaci",
  "forecastMaps.otherAreas": "Jiné oblasti",
  "forecastMaps.outsideArea": "Nepokrývá tuto oblast",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pozastavit",
  "forecastMaps.play": "Přehrát",
  "forecastMaps.pointValueAnnouncement": "{value}, {time}",
  "forecastMaps.pointValueError": "Předpověď pro tento bod se nepodařilo načíst.",
  "forecastMaps.pointValueLoading": "Načítání předpovědi…",
  "forecastMaps.pointValueUnavailable": "Pro tento čas nejsou k dispozici žádná data.",
  "forecastMaps.premiumModelForView": "{model} pokrývá tento pohled",
  "forecastMaps.premiumRequired": "Předpovědní mapy vyžadují Premium",
  "forecastMaps.preview": "Náhled",
  "forecastMaps.previewEmptyHint": "Pro vykreslení náhledu nastavte alespoň jednu platnou vrstvu.",
  "forecastMaps.previewFailed": "Náhled se nezdařil",
  "forecastMaps.previewHour": "Hodina předpovědi",
  "forecastMaps.previewRendering": "Vykreslování náhledu…",
  "forecastMaps.projection": "Projekce",
  "forecastMaps.projectionLambertConformal": "Lambertova konformní",
  "forecastMaps.projectionMercator": "Mercatorova",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stereografická",
  "forecastMaps.regionEurope": "Evropa",
  "forecastMaps.regionNorthAmerica": "Severní Amerika",
  "forecastMaps.removeColor": "Odebrat barvu",
  "forecastMaps.removeLayer": "Odebrat vrstvu",
  "forecastMaps.retry": "Zkusit znovu",
  "forecastMaps.run": "Běh: {run}",
  "forecastMaps.runNotDisplayable": "Tento běh nelze zobrazit na interaktivní mapě.",
  "forecastMaps.save": "Uložit",
  "forecastMaps.selectExtentOnMap": "Vybrat oblast na mapě",
  "forecastMaps.showArea": "Zobrazit oblast",
  "forecastMaps.showAreaOf": "Zobrazit oblast, {model}",
  "forecastMaps.south": "Jih",
  "forecastMaps.switchToModel": "Přepnout na {model}",
  "forecastMaps.title": "Předpovědní mapy",
  "forecastMaps.uMetric": "Složka U",
  "forecastMaps.unitConversion": "Převod jednotek",
  "forecastMaps.unitNone": "Žádný",
  "forecastMaps.unsavedChangesBody": "Máte neuložené změny. Odejít a zahodit je?",
  "forecastMaps.unsavedChangesTitle": "Neuložené změny",
  "forecastMaps.useCurrentView": "Použít aktuální zobrazení",
  "forecastMaps.useModelDomain": "Vypnuto: použije se celá oblast modelu",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Veličiny U a V se musí lišit",
  "forecastMaps.valueAtMapCentre": "Hodnota ve středu mapy",
  "forecastMaps.valueBetween": "Musí být mezi {min} a {max}",
  "forecastMaps.variable": "Veličina",
  "forecastMaps.variableMissing": "{variable} není k dispozici",
  "forecastMaps.variableOnlyFrom": "{variable}: poskytuje pouze {model}",
  "forecastMaps.viewMap": "Zobrazit mapu",
  "forecastMaps.vMetric": "Složka V",
  "forecastMaps.west": "Západ",
  "forecastMaps.windAnimation": "Animace větru",
  "forecastModels.addForecastModel": "Přidat model",
  "forecastModels.atYourStations": "Dostupné na vašich stanicích",
  "forecastModels.comparisonLoadError": "Porovnání modelů počasí se nepodařilo načíst",
  "forecastModels.coverageLoading": "Zjišťujeme, které z vašich stanic každý model pokrývá…",
  "forecastModels.description_AROME": "Vysokorozlišovací model Météo France umožňující řešení konvekce nad západní Evropou s rozlišením 1,3 km. Nejlepší ve své třídě pro krátkodobé předpovědi ve Francii; aktualizován každé tři hodiny.",
  "forecastModels.description_ARPEGE_EU": "Evropská vnořená oblast modelu ARPEGE Météo France s rozlišením 10 km. Střednědobé předpovědi nad Evropou, aktualizované čtyřikrát denně.",
  "forecastModels.description_ARPEGE_GLOBAL": "Globální numerický model počasí Météo France s rozlišením 25 km, běžící asi 4 dny. Aktualizován čtyřikrát denně.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI od DMI: model umožňující řešení konvekce nad severozápadní Evropou — Dánsko, Benelux, Irsko, Spojené království a Skandinávie — s rozlišením 2 km běžící až 60 hodin, aktualizován osmkrát denně. Obsahuje upravená otevřená data DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Global Deterministic Prediction System od Environment Canada: celosvětový střednědobý model s rozlišením 15 km běžící až 10 dní, aktualizován dvakrát denně.",
  "forecastModels.description_EC_HRDPS": "High Resolution Deterministic Prediction System od Environment Canada: model umožňující řešení konvekce nad Kanadou a severními Spojenými státy s rozlišením 2,5 km běžící až 48 hodin, aktualizován čtyřikrát denně.",
  "forecastModels.description_EC_RDPS": "Regional Deterministic Prediction System od Environment Canada: střednědobý model nad Severní Amerikou s rozlišením 10 km, aktualizován čtyřikrát denně.",
  "forecastModels.description_ECMWF_HRES": "Vlajkový model s vysokým rozlišením (IFS) Evropského centra pro střednědobé předpovědi počasí, všeobecně považovaný za nejlepší globální předpovědní systém na světě. Pokrývá celou planetu v rozlišení 25 km až na 15 dní, aktualizován čtyřikrát denně. Obsahuje upravená otevřená data ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "Vlajkový střednědobý globální model NOAA. Pokrývá celou planetu s rozlišením 25 km až do 16 dní, aktualizován čtyřikrát denně.",
  "forecastModels.description_HRRR_CONUS": "High-Resolution Rapid Refresh od NOAA: model umožňující řešení konvekce nad kontinentálními Spojenými státy s rozlišením 3 km, aktualizovaný každou hodinu. Nejvhodnější pro velmi krátkodobé předpovědi bouřek a silných meteorologických jevů.",
  "forecastModels.description_ICON": "Globální model ICON od DWD s rozlišením 13 km pokrývající celou planetu až na 7,5 dne, aktualizovaný čtyřikrát denně. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I od ItaliaMeteo, provozovaný společně s ARPAE: model umožňující řešení konvekce nad Itálií s rozlišením 2,2 km běžící až 72 hodin, aktualizován dvakrát denně. Obsahuje otevřená data ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Kontrolní běh ICON-CH1-EPS od MeteoSwiss: model umožňující řešení konvekce nad Alpami s rozlišením 1 km běžící až 33 hodin, aktualizován každé tři hodiny.",
  "forecastModels.description_ICON_CH2": "Kontrolní běh ICON-CH2-EPS od MeteoSwiss: model umožňující řešení konvekce nad Alpami — Švýcarsko a okolní alpský region — s rozlišením 2,1 km běžící až 120 hodin, aktualizován čtyřikrát denně.",
  "forecastModels.description_ICON_DE": "Vysokorozlišovací model DWD umožňující řešení konvekce nad Německem a sousedními zeměmi s rozlišením 2,2 km. Krátkodobé předpovědi aktualizované dvakrát denně. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Evropská vnořená oblast modelu ICON DWD s rozlišením 7 km pokrývající Evropu a severní Atlantik. Střednědobé předpovědi aktualizované čtyřikrát denně. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Otevřená služba předpovědi počasí Norského meteorologického ústavu, která kombinuje severské modely s vysokým rozlišením s daty ECMWF a poskytuje celosvětové předpovědi až 10 dní dopředu.",
  "forecastModels.description_MF_AROME_ANTILLES": "Vnořená oblast AROME nad francouzskými Antilami (Guadeloupe, Martinik) s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "forecastModels.description_MF_AROME_GUYANE": "Vnořená oblast AROME nad Francouzskou Guyanou s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Vnořená oblast AROME nad Novou Kaledonií s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Vnořená oblast AROME nad Francouzskou Polynésií s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Vnořená oblast AROME nad Réunionem a Mayotte s rozlišením 2,5 km. Krátkodobé předpovědi aktualizované čtyřikrát denně.",
  "forecastModels.description_RRFS_CONUS": "Systém Rapid Refresh Forecast od NOAA nad kontinentálními USA s rozlišením 3 km. Hodinové předpovědi aktualizované osmkrát denně, do 84 hodin u čtyř hlavních běhů a 18 hodin u ostatních.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "Systém Rapid Refresh Forecast od NOAA pokrývající celou Severní Ameriku s rozlišením 13 km. Hodinové předpovědi do 84 hodin, aktualizované čtyřikrát denně.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Vlajková předpověď SmartMixin. Pro každou hodinu na vašem místě vybíráme nejlepší dostupný model — obvykle vysokorozlišovací regionální model tam, kde existuje (AROME ve Francii, ICON-D2 v Německu, HRRR v USA, ARPEGE Europe napříč kontinentem…) a jinde se vracíme ke globálnímu modelu — poté zaplníme veškeré mezery ze sousedních zdrojů. Výsledkem je jediná bezproblémová předpověď pokrývající kdekoli na světě až 14 dní, automaticky aktualizovaná vždy, když je jeden z podkladových modelů aktualizován.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Vlastní globální předpověď Weatherflow, která kombinuje více numerických modelů počasí s pozorováními ze sítě meteorologických stanic Tempest. Celosvětový 10denní horizont.",
  "forecastModels.everywhereElse": "Všude jinde",
  "forecastModels.everywhereElseFoot": "Použije se na každé stanici, kam vaše preferované modely nedosáhnou.",
  "forecastModels.everywhereElsePick": "Vyberte jeden",
  "forecastModels.fallbackBlend": "Směs SmartMixin",
  "forecastModels.fallbackBlendSub": "Kombinuje několik modelů, každý tam, kde je nejsilnější.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES všude, kam dosáhne.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Globální model NOAA. To, co dnes používá každý účet.",
  "forecastModels.fallbackResolution": "Nejvyšší rozlišení",
  "forecastModels.fallbackResolutionSub": "Nejjemnější síť dostupná na každé stanici.",
  "forecastModels.forecastChipLabelWithRun": "{model}, běh {run}",
  "forecastModels.forecastChipRunHint": "Dlouhým stisknutím zobrazíte nebo skryjete poslední běh",
  "forecastModels.forecastComparisonDescription": "Snadno porovnávejte data z různých dostupných modelů počasí",
  "forecastModels.forecastFollowingPreferences": "Podle vašich předvoleb",
  "forecastModels.forecastLoadError": "Předpověď se nepodařilo načíst",
  "forecastModels.forecastModel": "Předpovědní model",
  "forecastModels.forecastModelAbout": "O modelu {model}",
  "forecastModels.forecastModelComparison": "Porovnání modelů počasí",
  "forecastModels.forecastModelCoverage": "Pokrytí",
  "forecastModels.forecastModelDescription": "Popis",
  "forecastModels.forecastModels": "Modely předpovědi",
  "forecastModels.forecastModelScopeGlobal": "Globální",
  "forecastModels.forecastModelScopeGlobalDescription": "Tento model pokrývá celou planetu.",
  "forecastModels.forecastModelScopeRegional": "Regionální",
  "forecastModels.forecastModelScopeRegionalDescription": "Tento model pokrývá pouze určitý region.",
  "forecastModels.forecastModelSpecifications": "Specifikace",
  "forecastModels.forecastNoPinLocation": "Na tuto polohu nedosáhne žádný preferovaný model — rozhoduje „všude jinde“.",
  "forecastModels.forecastNoPinStation": "Na tuto stanici nedosáhne žádný preferovaný model — rozhoduje „všude jinde“.",
  "forecastModels.forecastNoPreferredModels": "Zatím nejsou nastaveny žádné preferované modely.",
  "forecastModels.forecastOverrideElsewhere": "Vaše předvolby platí všude jinde.",
  "forecastModels.forecastPickForLocation": "Nebo vyberte jeden pro tuto polohu",
  "forecastModels.forecastPickForStation": "Nebo vyberte jeden pro tuto stanici",
  "forecastModels.forecastPinWinsLocation": "{model} — váš první preferovaný model, který dosáhne na tuto polohu.",
  "forecastModels.forecastPinWinsStation": "{model} — váš první preferovaný model, který dosáhne na tuto stanici.",
  "forecastModels.forecastServedNowHere": "Právě teď je to zde {model}",
  "forecastModels.forecastSetForLocation": "Nastaveno pro tuto polohu",
  "forecastModels.forecastSetForStation": "Nastaveno pro tuto stanici",
  "forecastModels.forecastSettingsRowSub": "Preferované modely a co platí všude jinde",
  "forecastModels.forecastStopUsingHere": "Zde už nepoužívat",
  "forecastModels.forecastUseForLocation": "Použít {model} pro tuto polohu",
  "forecastModels.forecastUseForStation": "Použít {model} pro tuto stanici",
  "forecastModels.forecastUsePreferred": "Použít mé preferované modely",
  "forecastModels.frequencyHourly": "Každou hodinu",
  "forecastModels.horizon": "Horizont",
  "forecastModels.horizonValue": "až {value} hodin",
  "forecastModels.meshSize": "Velikost mřížky",
  "forecastModels.pickerShowAll": "Zobrazit celý katalog",
  "forecastModels.pickerUnreachable": "{count, plural, one {# další model nedosáhne} few {# další modely nedosáhnou} many {# dalších modelů nedosáhne} other {# dalších modelů nedosáhne}} na žádnou z vašich stanic",
  "forecastModels.pinInUse": "Používá se",
  "forecastModels.pinShadowed": "Nikdy se nepoužije — model výše pokrývá všechny vaše stanice",
  "forecastModels.pinSlots": "{used} z {max} · vyberte model",
  "forecastModels.pinSlotsFull": "{max, plural, one {Jediné místo je obsazené. Odeberte jeho model, abyste mohli přidat jiný.} few {Všechna # místa jsou obsazená. Jedno odeberte, abyste mohli přidat další.} many {Všech # míst je obsazeno. Jedno odeberte, abyste mohli přidat další.} other {Všech # míst je obsazeno. Jedno odeberte, abyste mohli přidat další.}}",
  "forecastModels.pinsUncoveredCount": "{used} z vašich {count, plural, one {# stanice} few {# stanic} many {# stanic} other {# stanic}}: nedosáhne na {used, plural, =1 {ni} other {ně}} žádný preferovaný model — rozhoduje „všude jinde“.",
  "forecastModels.pinsUncoveredNamed": "{stations}: nedosáhne {count, plural, one {na ni} other {na ně}} žádný preferovaný model — rozhoduje „všude jinde“.",
  "forecastModels.pinUnreachable": "Nikdy se nepoužije — nedosáhne na žádnou z vašich stanic",
  "forecastModels.pinUsedAt": "Používá se na {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, one {Používá se na vaší stanici} few {Používá se na všech # stanicích} many {Používá se na všech # stanicích} other {Používá se na všech # stanicích}}",
  "forecastModels.pinUsedAtSome": "Používá se na {used} z {count, plural, one {# stanice} few {# stanic} many {# stanic} other {# stanic}}",
  "forecastModels.preferredModels": "Preferované modely",
  "forecastModels.preferredModelsAll": "Jeden seznam, všechny stanice",
  "forecastModels.preferredModelsOne": "Jeden seznam, platí všude",
  "forecastModels.publisher": "Vydavatel",
  "forecastModels.removePreferredModel": "Odebrat {model} z preferovaných modelů",
  "forecastModels.resetForecastPreference": "Obnovit výchozí",
  "forecastModels.resetForecastPreferenceHint": "Vymaže preferované modely a vrátí výchozí nastavení SmartMixin.",
  "forecastModels.servedNowMany": "Právě teď: GFS {count, plural, one {na vaší stanici} few {na všech # stanicích} many {na všech # stanicích} other {na všech # stanicích}}.",
  "forecastModels.servedNowNone": "Právě teď: GFS všude.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin multimodel",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Předpověď Weatherflow",
  "forecastModels.weatherForecastModels": "Modely předpovědi počasí",
  "helpCenter.articleCount": "{count, plural, one {# článek} few {# články} many {# článků} other {# článků}}",
  "helpCenter.articleNotFound": "Článek nenalezen",
  "helpCenter.articleNotFoundDescription": "Článek, který hledáte, neexistuje.",
  "helpCenter.backToHelpCenter": "Zpět do centra nápovědy",
  "helpCenter.browseByCategory": "Procházet podle kategorie",
  "helpCenter.categoryNotFound": "Kategorie nenalezena",
  "helpCenter.categoryNotFoundDescription": "Tato kategorie neexistuje nebo neobsahuje žádné články.",
  "helpCenter.contactSupport": "Kontaktovat podporu",
  "helpCenter.feedbackHelpsImprove": "Vaše připomínky nám pomáhají zlepšovat naše články nápovědy.",
  "helpCenter.feedbackReasonNotAnswer": "Neodpovídá na mou otázku",
  "helpCenter.feedbackReasonOutdated": "Informace jsou zastaralé",
  "helpCenter.feedbackReasonUnclear": "Pokyny jsou nejasné",
  "helpCenter.feedbackWhatWentWrong": "V čem byl problém?",
  "helpCenter.helpCategoryAccount": "Účet",
  "helpCenter.helpCategoryBilling": "Fakturace",
  "helpCenter.helpCategoryForecast": "Předpovědi",
  "helpCenter.helpCategoryGettingStarted": "Začínáme",
  "helpCenter.helpCategoryProviders": "Poskytovatelé",
  "helpCenter.helpCategoryStations": "Stanice",
  "helpCenter.helpCategoryTroubleshooting": "Řešení problémů",
  "helpCenter.helpCenter": "Centrum nápovědy",
  "helpCenter.landingDescription": "Najděte odpovědi na časté otázky a zjistěte, jak co nejlépe využít SmartMixin.",
  "helpCenter.linkToSection": "Odkaz na tuto sekci",
  "helpCenter.menuItemDescription": "Často kladené otázky a návody",
  "helpCenter.minRead": "{minutes} min čtení",
  "helpCenter.onThisPage": "Na této stránce",
  "helpCenter.platformMobileApp": "Mobilní aplikace",
  "helpCenter.platformMobileOnly": "Pouze v mobilní aplikaci",
  "helpCenter.platformWebApp": "Webová aplikace",
  "helpCenter.platformWebOnly": "Pouze ve webové aplikaci",
  "helpCenter.popularArticles": "Oblíbené články",
  "helpCenter.relatedArticles": "Související články",
  "helpCenter.searchArticles": "Hledat články...",
  "helpCenter.stillNeedHelp": "Stále potřebujete pomoc?",
  "helpCenter.stillNeedHelpDescription": "Pokud tento článek nezodpověděl vaši otázku, rád vám pomohu osobně.",
  "helpCenter.supportEmailSubject": "Podpora SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Podpora SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Děkujeme za vaši zpětnou vazbu!",
  "helpCenter.wasArticleHelpful": "Byl tento článek užitečný?",
  "intro.locationDescription": "Povolte přístup k lokaci pro přesné předpovědi šité na míru vaší přesné oblasti — žádné univerzální předpovědi.",
  "intro.locationTitle": "Předpovědi vytvořené pro vás",
  "intro.notificationDescription": "Zapněte oznámení pro včasná upozornění o změnách počasí, na kterých vám záleží — déšť, sníh nebo extrémní podmínky, právě kdy je to potřeba.",
  "intro.notificationsTitle": "Nepropásněte žádnou změnu počasí",
  "intro.readyDescription": "Užijte si přesné předpovědi, aktuální meteorologické informace a data ze stanic po celém světě — vše v jedné výkonné aplikaci.",
  "intro.readyTitle": "Vše je připraveno!",
  "intro.welcomeDescription": "Získejte hyperlokální předpovědi od předních meteorologických agentur — navíc přístup k více než 40 000 meteorologickým stanicím po celém světě pro reálné podmínky, jak aktuální, tak historické.",
  "intro.welcomeTitle": "Vaše počasí, znovu promyšlené",
  "landing.alsoAvailableOn": "K dispozici také na:",
  "landing.featureAlertsDescription": "Nastavte si vlastní prahové hodnoty pro jakoukoli veličinu. Dostanete upozornění, když klesne teplota, začne pršet nebo se zvedne vítr.",
  "landing.featureAlertsTitle": "Chytrá upozornění",
  "landing.featureAnalyticsDescription": "Interaktivní grafy, analýza trendů a podrobné statistiky. Ponořte se do dat o teplotě, vlhkosti, tlaku, dešti a větru.",
  "landing.featureAnalyticsTitle": "Pokročilá analytika",
  "landing.featureExportDescription": "Získejte všechna svá meteorologická data e-mailem jako tabulku Excel, připravenou k další analýze v Excelu, Tabulkách Google nebo ve vašich oblíbených nástrojích.",
  "landing.featureExportTitle": "Exportujte svá data",
  "landing.featureForecastDescription": "Přístup k {count, plural, one {#+ profesionálnímu předpovědnímu modelu} few {#+ profesionálním předpovědním modelům} many {#+ profesionálním předpovědním modelům} other {#+ profesionálním předpovědním modelům}} včetně ECMWF, GFS a regionálních modelů. Porovnejte je vedle sebe a udělejte si vlastní předpověď.",
  "landing.featureForecastTitle": "Porovnejte předpovědní modely",
  "landing.featureHistoryDescription": "Přístup k historickým datům v hodinovém, denním a měsíčním měřítku. Exportujte je do Excelu pro výzkum nebo osobní archivy.",
  "landing.featureHistoryTitle": "Bohatá historie",
  "landing.featureMultiBrandDescription": "Připojte Netatmo, Davis, Tempest, Ecowitt, Ambient Weather a další. Už žádné přepínání mezi aplikacemi.",
  "landing.featureMultiBrandTitle": "Všechny značky, jedna aplikace",
  "landing.featuresSubtitle": "SmartMixin vám dává nástroje, abyste mohli analyzovat, porovnávat a chápat svá meteorologická data jako profesionál.",
  "landing.featuresTitle": "Vytvořeno pro milovníky dat",
  "landing.finalCtaButton": "Vytvořit účet zdarma",
  "landing.finalCtaSubtitle": "Připojte se k tisícům nadšenců do počasí, kteří důvěřují SmartMixinu.",
  "landing.finalCtaTitle": "Chcete se ponořit hlouběji do svých meteorologických dat?",
  "landing.heroCta": "Začít zdarma",
  "landing.heroDescription": "Hloubková analytika, krásné grafy a profesionální předpovědi — všechny vaše meteorologické stanice sjednocené v jedné výkonné aplikaci.",
  "landing.heroSecondaryCta": "Prozkoumat mapu",
  "landing.heroTagline": "Pro nadšence do počasí",
  "landing.heroTitle": "Sledujte své počasí jako nikdy předtím",
  "landing.pricingComparisonCaption": "Srovnání funkcí bezplatného plánu a Premium",
  "landing.pricingFeatureAdvancedMetrics": "Pokročilé metriky",
  "landing.pricingFeatureAlerts": "Vlastní upozornění",
  "landing.pricingFeatureColumn": "Funkce",
  "landing.pricingFeatureExport": "Export dat (Excel)",
  "landing.pricingFeatureForecastComparison": "Porovnání předpovědí",
  "landing.pricingFeatureForecasts": "Modely předpovědi",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ model} few {#+ modely} many {#+ modelů} other {#+ modelů}}",
  "landing.pricingFeatureReports": "Analýzy a reporty",
  "landing.pricingFeatureStationComparison": "Srovnání stanic",
  "landing.pricingFeatureWidgets": "Widgety domovské obrazovky",
  "landing.pricingFeatureYearOverYear": "Meziroční analýza",
  "landing.pricingFreeCta": "Začít",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Nejoblíbenější",
  "landing.pricingPremiumCta": "Začít",
  "landing.pricingPremiumDescription": "Od 1,99 €/měsíc — předplaťte si na webu, App Store nebo Google Play",
  "landing.pricingSubtitle": "Začněte zdarma, upgradujte, když potřebujete více.",
  "landing.pricingTitle": "Jednoduchý, transparentní ceník",
  "landing.statBrands": "Podporovaných značek",
  "landing.statForecasts": "Modelů předpovědi",
  "landing.statStations": "Meteorologických stanic",
  "landing.supportedDevicesNote": "Plus více než {count, number} veřejných stanic ze sítě Světové meteorologické organizace",
  "landing.supportedDevicesSubtitle": "Připojte svou stávající meteorologickou stanici během několika minut. Podporujeme {count, plural, one {# hlavní značku} few {# hlavní značky} many {# hlavních značek} other {# hlavních značek}} a další přibývají.",
  "landing.supportedDevicesTitle": "Funguje s vaší stanicí",
  "metrics.absolutePressure": "Absolutní tlak",
  "metrics.airDensity": "Hustota vzduchu",
  "metrics.airGap": "Vzduchová mezera",
  "metrics.apparentTemperature": "Zdánlivá teplota",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Prům.",
  "metrics.avg_wind": "Průměrný vítr",
  "metrics.beaufort": "Beaufort",
  "metrics.blackGlobeTemperature": "Teplota černého globu",
  "metrics.boilerOn": "Ohřev zapnutý",
  "metrics.boilerOnInHours": "Ohřev zapnutý (hodiny)",
  "metrics.cloudCover": "Oblačnost",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Vodivost",
  "metrics.dailyPrecipitation": "Denní srážky",
  "metrics.dailyRain": "Denní déšť",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Hloubka",
  "metrics.depthSensors": "Senzory hloubky",
  "metrics.dewPoint": "Rosný bod",
  "metrics.distance": "Vzdálenost",
  "metrics.downTrend": "Sestupný trend",
  "metrics.ET": "Evapotranspirace",
  "metrics.etToday": "ET dnes",
  "metrics.feelsLike": "Pocitová teplota",
  "metrics.feelsLikeWithFormula": "Pocitová teplota ({formula})",
  "metrics.frostPoint": "Bod ojínění",
  "metrics.gust": "Náraz",
  "metrics.gustDirection": "Směr nárazu",
  "metrics.hail": "Kroupy",
  "metrics.heatIndex": "Tepelný index",
  "metrics.heatingDegreeDays": "Denostupně vytápění",
  "metrics.heatingPower": "Topný výkon",
  "metrics.humidex": "Humidex",
  "metrics.humidity": "Vlhkost",
  "metrics.lastLightningImpact": "Poslední úder blesku",
  "metrics.lastMeasure": "Poslední měření",
  "metrics.leafSensors": "Senzory listů",
  "metrics.leafWetness": "Vlhkost listů",
  "metrics.lightningDistance": "Vzdálenost",
  "metrics.lightningStrikeCount": "Počet úderů blesku",
  "metrics.lightningStrikeDistance": "Vzdálenost úderu blesku",
  "metrics.max": "Max.",
  "metrics.max_gust": "Max. náraz",
  "metrics.maxToday": "Max. dnes",
  "metrics.min": "Min.",
  "metrics.noise": "Hluk",
  "metrics.normalizedHeatingCoefficient": "Normalizovaný topný koeficient",
  "metrics.outdoorTemperature": "Venkovní teplota",
  "metrics.PM_1": "PM 1",
  "metrics.PM_10": "PM 10",
  "metrics.PM_2P5": "PM 2.5",
  "metrics.precipitation": "Srážky",
  "metrics.pressure": "Tlak",
  "metrics.rain": "Srážky",
  "metrics.rainDurationValue": "Doba trvání deště: {duration}",
  "metrics.rainfallMeasurement": "Měření srážek",
  "metrics.rainRate": "Intenzita deště",
  "metrics.relativePressure": "Relativní tlak",
  "metrics.setPoint": "Požadovaná teplota",
  "metrics.snow": "Sníh",
  "metrics.snowfall": "Sněžení",
  "metrics.soilMoisture": "Půdní vlhkost",
  "metrics.soilSensors": "Půdní senzory",
  "metrics.soilWaterTension": "Sací tlak půdy",
  "metrics.solarEnergy": "Solární energie",
  "metrics.solarRadiation": "Solární radiace",
  "metrics.speed": "Rychlost",
  "metrics.stableTrend": "Stabilní trend",
  "metrics.sum": "Součet",
  "metrics.temperature": "Teplota",
  "metrics.temperatureSensors": "Senzory teploty/vlhkosti",
  "metrics.temperatureShort": "Tepl.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "Vzestupný trend",
  "metrics.uv": "UV",
  "metrics.visibility": "Viditelnost",
  "metrics.weatherCondition": "Počasí",
  "metrics.wetBulbGlobeTemperature": "Teplota WBGT",
  "metrics.wetBulbTemperature": "Temp. vlhkého teploměru",
  "metrics.wind": "Vítr",
  "metrics.windChill": "Wind Chill",
  "metrics.windDirection": "Směr větru",
  "metrics.windMeasurement": "Měření větru",
  "metrics.windRun": "Dráha větru",
  "metrics.windRunDescription": "Dráha větru je celková vzdálenost, kterou vítr urazí za určité časové období",
  "metrics.windSpeed": "Rychlost větru",
  "navigation.allFavorites": "Zobrazit všechny",
  "navigation.breadcrumbs": "Drobečková navigace",
  "navigation.collapseNavigation": "Sbalit navigaci",
  "navigation.expandNavigation": "Rozbalit navigaci",
  "navigation.main": "Hlavní",
  "navigation.mapShort": "Mapa",
  "navigation.skipToContent": "Přeskočit na hlavní obsah",
  "navigation.stationsShort": "Stanice",
  "network.cancelError": "Požadavek byl zrušen",
  "network.connectionError": "Server není dostupný",
  "network.networkError": "Síť není dostupná",
  "network.serverError": "Něco se pokazilo...",
  "network.timeoutError": "Časový limit spojení vypršel",
  "network.unknownError": "Neznámá chyba",
  "premium.alreadyPremium": "Již máte prémiový účet!",
  "premium.bestValue": "Nejvýhodnější",
  "premium.billingDetailsAndroid": "Bezplatná zkušební doba: pokud ji zrušíte alespoň 24 hodin před jejím koncem, nic vám nebude účtováno. Poté se vaše předplatné SmartMixin automaticky obnovuje, pokud ho nezrušíte alespoň 24 hodin před koncem aktuálního období; zrušit ho můžete kdykoli v nastavení svého účtu Google Play. Každé obnovení je účtováno za cenu uvedenou na tlačítku výše. Platba je účtována na váš účet Google Play při potvrzení nákupu a na začátku každého obnovovacího období.",
  "premium.billingDetailsIos": "Bezplatná zkušební doba: pokud ji zrušíte alespoň 24 hodin před jejím koncem, nic vám nebude účtováno. Poté se vaše předplatné SmartMixin automaticky obnovuje, pokud ho nezrušíte alespoň 24 hodin před koncem aktuálního období; zrušit ho můžete kdykoli v nastavení svého účtu App Store. Každé obnovení je účtováno za cenu uvedenou na tlačítku výše. Platba je účtována na váš účet App Store při potvrzení nákupu a na začátku každého obnovovacího období.",
  "premium.freeBannerBody": "Bezplatné účty dostávají všude GFS — vaše preferované modely i „všude jinde“ začnou fungovat ve chvíli, kdy si předplatíte.",
  "premium.freeBannerTitle": "Předvolby platí s Premium",
  "premium.freeSubscription": "Předplatné zdarma",
  "premium.freeTrialForPeriod": "Bezplatná zkušební doba na {period, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "premium.getUnlimitedAccess": "Neomezený přístup k:",
  "premium.manageMySubscription": "Spravovat mé předplatné",
  "premium.notPurchasedYet": "Pro tento účet obchodu nebyl nalezen žádný nákup SmartMixin Premium.",
  "premium.orChooseMonthly": "Nebo zvolte měsíčně:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Aktivní",
  "premium.premiumAnnualTrialInfo": "Začněte s bezplatnou zkušební dobou na {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}",
  "premium.premiumCurrentPlan": "Aktuální plán",
  "premium.premiumDownloadApp": "Stáhněte aplikaci pro předplatné:",
  "premium.premiumEndsOn": "Vyprší {date}",
  "premium.premiumFeatureAlerts": "Upozornění na počasí",
  "premium.premiumFeatureAnalysis": "Pokročilá analýza počasí",
  "premium.premiumFeatureCharts": "Porovnání grafů",
  "premium.premiumFeatureExport": "Export dat",
  "premium.premiumFeatureForecast": "Regionální předpovědní modely",
  "premium.premiumFeatureNotification": "Widget stavového řádku",
  "premium.premiumFeatureTitle": "Funkce Premium",
  "premium.premiumFeatureWidgets": "Widgety domovské obrazovky",
  "premium.premiumFreePlan": "Zdarma",
  "premium.premiumInactive": "Bez předplatného",
  "premium.premiumManageStoreSubscription": "Předplatné jste zakoupili přes {store}. Tam ho můžete spravovat nebo zrušit.",
  "premium.premiumManageWebSubscription": "Spravujte své předplatné, aktualizujte platební metodu nebo zrušte.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Obnovuje se {date}",
  "premium.premiumSubscribeAnnual": "Ročně — 9,99 €/rok",
  "premium.premiumSubscribedOn": "Předplaceno přes {platform}",
  "premium.premiumSubscribedOnWeb": "Předplaceno přes web",
  "premium.premiumSubscribeMonthly": "Měsíčně — 1,99 €/měsíc",
  "premium.premiumSubscribeOnWeb": "Přihlaste se k odběru a odemkněte všechny prémiové funkce.",
  "premium.premiumSubscriptionSuccess": "Vaše předplatné bylo aktivováno! Užijte si všechny prémiové funkce.",
  "premium.premiumSubscriptionSuccessTitle": "Vítejte v Premium!",
  "premium.premiumWebappNotice": "Předplatné přes web teď není k dispozici.",
  "premium.pricePerMonth": "{price}/měsíc",
  "premium.pricePerYear": "{price}/rok",
  "premium.purchasedNetatmoPro": "Dříve jste zakoupili Netatmo Pro ({date}). Získáte tak přístup k části prémiových funkcí. Pokud chcete mít přístup ke všem prémiovým funkcím, předplaťte si jednu z níže uvedených nabídek.",
  "premium.purchaseFailed": "Nákup se nepodařilo dokončit. Zkuste to prosím znovu.",
  "premium.restoreFailed": "Nákupy se nepodařilo obnovit. Zkuste to prosím znovu.",
  "premium.restorePurchase": "Obnovit nákup",
  "premium.savingsPercent": "Ušetříte {percent}%",
  "premium.seePremium": "Zobrazit Premium",
  "premium.startFreeTrial": "Zahájit bezplatnou zkušební verzi",
  "premium.storeUnavailable": "Obchod teď není dostupný. Zkuste to prosím později.",
  "premium.subscribeNow": "Předplatit nyní — bez zkušební doby",
  "premium.switchToPremium": "Přepnout na SmartMixin Premium",
  "premium.thenPrice": "poté {price}",
  "providerHints.ambientWeatherApiKey": "Vytvořeno v nastavení vašeho účtu na ambientweather.net.",
  "providerHints.davisApiSecret": "Zobrazí se pouze jednou při vytvoření V2 API klíče — uchovejte v bezpečí.",
  "providerHints.davisV2ApiKey": "Ze stránky V2 API klíčů na weatherlink.com.",
  "providerHints.ecowittApi": "Ze stránky API vašeho účtu Ecowitt.",
  "providerHints.ecowittApp": "Klíč aplikace, také z vašeho účtu Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Použijte e-mail a heslo vašeho účtu My AcuRite — nikoli přihlášení do SmartMixin.",
  "providerHints.myAcuriteEmail": "E-mail vašeho účtu My AcuRite — nikoli vaše přihlášení do SmartMixin.",
  "providerHints.myAcuritePassword": "Heslo vašeho účtu My AcuRite.",
  "providerHints.weatherflowToken": "Osobní token z tempestwx.com → nastavení → autorizace dat.",
  "providerHints.wundergroundEditKey": "Použít jiný klíč",
  "providerHints.wundergroundKey": "Dlouhý řetězec ze stránky API klíčů vašeho účtu Weather Underground — nikoli vaše heslo na wunderground.com.",
  "providerHints.wundergroundKeyExample": "např. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API klíč ověřen",
  "providerHints.wundergroundNoStationsNearby": "V okolí této lokality nebyly nalezeny žádné stanice. Zkuste zadat ID stanice přímo.",
  "providerHints.wundergroundStationIdExample": "např. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Získejte svůj API klíč Ambient Weather.",
  "providerIntro.davisStep2": "Získejte svůj V2 API klíč a API tajemství Davis.",
  "providerIntro.ecowittStep2": "Získejte svůj API klíč a klíč aplikace Ecowitt.",
  "providerIntro.getStarted": "Začít",
  "providerIntro.myAcuriteStep2": "Použijte e-mail a heslo vašeho stávajícího účtu My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Přihlaste se k Netatmo, když budete vyzváni — API klíč není potřeba.",
  "providerIntro.netatmoWeatherStep2": "Přihlaste se k Netatmo, když budete vyzváni — API klíč není potřeba.",
  "providerIntro.signupBanner": "Téměř hotovo — vytvořte si bezplatný účet SmartMixin pro připojení {provider}.",
  "providerIntro.step1": "Přihlaste se ke svému účtu SmartMixin (NIKOLIV k {provider}).",
  "providerIntro.step3EmailPassword": "Zadejte sem.",
  "providerIntro.step3KeyOrToken": "Vložte sem.",
  "providerIntro.step3OAuth": "Autorizujte SmartMixin ve vyskakovacím okně.",
  "providerIntro.step3Wunderground": "Vložte svůj API klíč a poté vyberte stanici v blízkosti nebo zadejte libovolné ID stanice.",
  "providerIntro.stepOfTotal": "Krok {step} z {total}",
  "providerIntro.title": "Připojit {provider}",
  "providerIntro.weatherflowStep2": "Získejte svůj osobní Tempest token.",
  "providerIntro.wundergroundBrowsePublic": "Nemáte stanici? Procházejte veřejné",
  "providerIntro.wundergroundFindNearby": "Najít stanice v okolí",
  "providerIntro.wundergroundOrEnterId": "Nebo zadat ID stanice",
  "providerIntro.wundergroundStep2": "Získejte svůj API klíč Weather Underground. Poté budete moci připojit jakoukoli stanici — vlastní nebo veřejnou.",
  "reports.agroMeteorology": "Agrometeorologie",
  "reports.analysis": "Analýza",
  "reports.annualCumulativeRainfallComparison": "Porovnání ročních úhrnů srážek",
  "reports.annualHeatingDurationComparison": "Roční srovnání doby vytápění",
  "reports.annualHeatingEfficiency": "Roční účinnost vytápění",
  "reports.annualIndoorComparison": "Roční srovnání - uvnitř",
  "reports.annualOutdoorComparison": "Roční porovnání - venku",
  "reports.annualOutdoorReport": "Roční souhrn - venku",
  "reports.annualReport": "Roční report",
  "reports.annualSolarReport": "Roční solární zpráva",
  "reports.annualWaterBalance": "Roční vodní bilance",
  "reports.annualWaterBalanceCarryOver": "Převést z roku {year} ({value})",
  "reports.annualWaterBalanceDescription": "Vodní bilance (zjednodušená verze, používá se pouze déšť a evapotranspirace) umožňuje hospodaření s vodními zdroji",
  "reports.avgHumidity": "Průměrná vlhkost",
  "reports.avgMaxTemperature": "Průměrné teplotní maximum",
  "reports.avgMetric": "Průměr – {metric}",
  "reports.avgMinTemperature": "Průměrné teplotní minimum",
  "reports.avgPressure": "Průměrný tlak",
  "reports.avgTemperature": "Průměrná teplota",
  "reports.chartsAndTable": "Grafy a tabulka",
  "reports.climateNormalPeriodOfRecord": "Období měření ({years, plural, one {# rok} few {# roky} many {# roku} other {# let}})",
  "reports.climateNormals": "Klimatické normály",
  "reports.climateNormalStandardLabel": "Standardní normál ({period})",
  "reports.climateTrendPerDecade": "Trend teploty: {value} za desetiletí během {years, plural, one {# roku} few {# let} many {# let} other {# let}}",
  "reports.coldestMonthRanking": "Nejchladnější {month} v historii měření",
  "reports.comfortable": "Komfortní (45% {lessThan} vlhkost ≤ 60%)",
  "reports.cumulativeRainfall": "Kumulativní srážky",
  "reports.cumulativeRainfallDescription": "Sledujte celkový úhrn srážek nahromaděných za zvolené období.",
  "reports.dailyMaxRainfall": "Max. denní srážky",
  "reports.dataExport": "Export dat",
  "reports.dataExportXlsxFormatDescription": "Exportujte všechna data stanice ve formátu aplikace Excel (* .xlsx). Jakmile kliknete na tlačítko, obdržíte e-mail s zpracovanými daty po několika minutách.",
  "reports.daysOfData": "{days, plural, one {# den} few {# dny} many {# dne} other {# dní}} dat",
  "reports.daysWithFrost": "Mrazových dní",
  "reports.daysWithHeavyRain": "Dny s vydatným deštěm (≥ {threshold})",
  "reports.daysWithoutThaw": "Ledových dní",
  "reports.daysWithStrongFrost": "Dní se silným mrazem",
  "reports.emailSent": "Byla vám zaslána e-mailová zpráva",
  "reports.frostDays": "Mrazové dny",
  "reports.grasslandTemperatureSum": "Součet teplot travních porostů",
  "reports.grasslandTemperatureSumDescription": "Udržitelná obnova vegetace, když součet dosáhne {threshold}",
  "reports.growingDegreeDays": "Růstové stupňodny",
  "reports.highPressure": "Tlaková výše (Průměrný tlak ≥ {threshold})",
  "reports.iceDays": "Ledové dny",
  "reports.indoorReport": "Vnitřní hlášení",
  "reports.keyFacts": "Hlavní fakta",
  "reports.longestDrySpell": "Nejdelší bezsrážkové období",
  "reports.longestRunOfRainyDays": "Počet po sobě jdoucích deštivých dnů",
  "reports.longestRunWithoutRun": "Počet po sobě jdoucích dnů bez deště",
  "reports.longestWetSpell": "Nejdelší období srážek",
  "reports.lowPressure": "Tlaková níže (Průměrný tlak {lessThan} {threshold})",
  "reports.maxHumidity": "Maximální vlhkost",
  "reports.maxMetric": "Maximum – {metric}",
  "reports.maxPressure": "Maximální tlak",
  "reports.maxTemperature": "Maximální teplota",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Maximální denní amplituda (/24 h)",
  "reports.minHumidity": "Minimální vlhkost",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Minimální tlak",
  "reports.minTemperature": "Minimální teplota",
  "reports.minTempMagnitude24h": "Minimální denní amplituda (/24 h)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Ještě # den} few {Ještě # dny} many {Ještě # dne} other {Ještě # dní}} tento měsíc",
  "reports.monthlyAverageCountdownDetail": "Poté se zobrazí průměr tohoto měsíce a jeho pořadí.",
  "reports.monthlyAverageRule": "Měsíční průměry a pořadí se zobrazí, jakmile kalendářní měsíc má zaznamenáno {days, plural, one {# den} few {# dny} many {# dne} other {# dní}}.",
  "reports.monthlyHeatingEfficiency": "Měsíční souhrn - účinnost vytápění",
  "reports.monthlyOutdoorReport": "Měsíční souhrn - venku",
  "reports.monthlyReport": "Měsíční report",
  "reports.monthlySolarReport": "Měsíční solární zpráva",
  "reports.monthlyWindReport": "Měsíční souhrn - vítr",
  "reports.monthsOfData": "{months, plural, one {# měsíc} few {# měsíce} many {# měsíce} other {# měsíců}} dat",
  "reports.numberOfDays": "Počet dní",
  "reports.outdoorReport": "Souhrn - venku",
  "reports.overviewSection": "Přehled",
  "reports.rainfall": "Srážky",
  "reports.rainyDays": "Deštivých dní",
  "reports.recordClimatologicalDay": "Klimatologický den (06–06 UTC)",
  "reports.recordClimDayBody": "Srážky se zde sčítají po kalendářních dnech, od půlnoci do půlnoci místního času stanice. Meteorologické služby je sčítají od 06:00 do 06:00 UTC, takže bouřka kolem půlnoci může z jiného dne udělat ten nejdeštivější.",
  "reports.recordDailyRain": "Nejdeštivější den",
  "reports.recordFromHourlyReadings": "Z hodinových měření",
  "reports.recordHigh": "Rekordní maximum",
  "reports.recordLow": "Rekordní minimum",
  "reports.recordOfficialBody": "Meteorologická služba zveřejňuje pro tuto stanici denní maximum a minimum odečtené z maximálního a minimálního teploměru. Zachytí krátké špičky, které hodinová měření nezaznamenají, a proto nahrazují hodnoty vypočtené z hodinových měření.",
  "reports.recordOfficialValue": "Oficiální hodnota",
  "reports.recordsAndClimatology": "Rekordy a klima",
  "reports.recordSheetTitle": "O těchto rekordech",
  "reports.recordsSince": "Rekordy od {date}",
  "reports.recordWindGust": "Nejsilnější poryv větru",
  "reports.relativelyWet": "Poměrně vlhké (60% {lessThan} vlhkost ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# zpráva} few {# zprávy} many {# zpráv} other {# zpráv}}",
  "reports.sendEmail": "Odeslat e-mail",
  "reports.summerDays": "Letní dny",
  "reports.tableScrollRegion": "{title}, posouvá se vodorovně",
  "reports.tooDry": "Velmi suché (vlhkost ≤ 45%)",
  "reports.tooWet": "Velmi vlhké (vlhkost {greaterThan} 80%)",
  "reports.tropicalNights": "Tropických nocí",
  "reports.unlockPremiumSubtitle": "Součástí SmartMixin Premium",
  "reports.unlockPremiumTitle": "Odemkněte {count, plural, one {# prémiovou funkci} few {# prémiové funkce} many {# prémiových funkcí} other {# prémiových funkcí}}",
  "reports.warmestMonthRanking": "Nejteplejší {month} v historii měření",
  "reports.waterBalance": "Vodní bilance",
  "reports.yearsOfData": "{years, plural, one {# rok} few {# roky} many {# roku} other {# let}} dat",
  "reports.yearToDateTemperatureComparison": "Srovnání teplot od začátku roku",
  "sensors.bgtSensors": "Černý globus a WBGT",
  "sensors.cameraFeed": "Kamera",
  "sensors.compareHumidity": "Porovnat vlhkost",
  "sensors.compareMoisture": "Porovnat půdní vlhkost",
  "sensors.comparePm25": "Porovnat PM2.5",
  "sensors.compareTemperatures": "Porovnat teploty",
  "sensors.compareWaterTension": "Porovnat sací tlak půdy",
  "sensors.depthByChannel": "Hloubka podle kanálu",
  "sensors.heatStressExtreme": "Extrémní tepelný stres",
  "sensors.heatStressModerate": "Mírný tepelný stres",
  "sensors.heatStressNone": "Žádný tepelný stres",
  "sensors.heatStressStrong": "Silný tepelný stres",
  "sensors.heatStressVeryStrong": "Velmi silný tepelný stres",
  "sensors.indoorClimate": "Vnitřní klima",
  "sensors.indoorCo2Levels": "Úrovně CO2",
  "sensors.indoorTemperatureAndHumidity": "Teplota a vlhkost",
  "sensors.leafWetnessByChannel": "Vlhkost listů podle kanálu",
  "sensors.lightningSensor": "Blesk",
  "sensors.moistureByChannel": "Půdní vlhkost podle kanálu",
  "sensors.noDataAvailable": "Žádná data nejsou k dispozici",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 podle kanálu",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Vyberte kanál",
  "sensors.sensorDetailDescription": "Zobrazení historických dat a trendů pro kanály senzoru.",
  "sensors.sensorHistory": "Historie senzoru",
  "sensors.soilConductivityByChannel": "Vodivost podle kanálu",
  "sensors.soilTemperatureByChannel": "Teplota půdy podle kanálu",
  "sensors.strikesToday": "Údery dnes",
  "sensors.temperatureByChannel": "Teplota podle kanálu",
  "sensors.viewChart": "Zobrazit graf",
  "sensors.waterTensionByChannel": "Sací tlak půdy podle kanálu",
  "settings.appearance": "Vzhled",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabština",
  "settings.bulgarian": "bulharština",
  "settings.catalan": "katalánština",
  "settings.chartGestures": "Gesta v grafech",
  "settings.chartGesturesDescription": "Přejetím po grafech změníte časové období, stažením grafů změníte časové měřítko",
  "settings.choiceCount": "{count, plural, one {Dostupný: #} few {Dostupné: #} many {Dostupných: #} other {Dostupných: #}}",
  "settings.contactUs": "Kontaktujte nás",
  "settings.contactUsDescription": "Získejte pomoc nebo pošlete zpětnou vazbu",
  "settings.croatian": "chorvatština",
  "settings.czech": "čeština",
  "settings.dailyDetailByPeriods": "Denní detail po částech dne",
  "settings.dailyDetailByPeriodsDescription": "Seskupí 24 hodin do noci, rána, odpoledne a večera — stejné rozdělení, jaké používá souhrn dne.",
  "settings.danish": "dánština",
  "settings.dark": "Tmavý motiv",
  "settings.dataDisplay": "Zobrazení dat",
  "settings.dateAndTime": "Datum a čas",
  "settings.donateButton": "Přispět darem",
  "settings.donateDescription": "SmartMixin vytváří malý tým. Pokud je pro vás užitečný, můžete podpořit jeho vývoj jednorázovým darem v libovolné výši. Je to dar — nemění váš tarif ani neodemyká žádné funkce.",
  "settings.donateSuccessBody": "Váš dar pomáhá udržet SmartMixin v provozu a zlepšovat ho. Velmi si toho vážíme.",
  "settings.donateSuccessTitle": "Děkujeme za vaši podporu!",
  "settings.donateTitle": "Podpořte SmartMixin",
  "settings.dragToReorder": "Přetažením změníte pořadí",
  "settings.dutch": "holandština",
  "settings.english": "angličtina",
  "settings.french": "francouzština",
  "settings.german": "němčina",
  "settings.gestures": "Gesta",
  "settings.greek": "řečtina",
  "settings.hungarian": "maďarština",
  "settings.italian": "italština",
  "settings.japanese": "japonština",
  "settings.korean": "korejština",
  "settings.language": "Jazyk",
  "settings.languageDescription": "Preferovaný jazyk",
  "settings.light": "Světlý motiv",
  "settings.measurementUnits": "Měrné jednotky",
  "settings.netatmoDashboard": "Přehled Netatmo",
  "settings.netatmoLayoutCards": "Seznam karet",
  "settings.netatmoLayoutCardsDescription": "Jedna karta na modul, vše v jednom rolování",
  "settings.netatmoLayoutClassic": "Klasické",
  "settings.netatmoLayoutClassicDescription": "Dvě karty, přepínání mezi moduly",
  "settings.netatmoNewLayoutNotice": "Nové rozvržení přehledu: jedna karta na modul.",
  "settings.netatmoSwitchBackToClassic": "Zpět na klasické",
  "settings.netatmoSwitchToLayout": "Přepnout na {layout}",
  "settings.norwegian": "norština",
  "settings.notificationsSection": "Oznámení",
  "settings.ongoingNotificationEnabled": "Povolit trvalé oznámení",
  "settings.ongoingNotificationMetrics": "Zobrazené metriky",
  "settings.ongoingNotificationPermissionRequired": "Je vyžadováno oprávnění k oznámením",
  "settings.ongoingNotificationPreviewHint": "Náhled — zapněte widget, aby se zobrazil",
  "settings.ongoingNotificationStatusBar": "Stavový řádek",
  "settings.polish": "polština",
  "settings.portuguese": "portugalština",
  "settings.preferencesSection": "Předvolby",
  "settings.privacyPolicy": "Zásady ochrany osobních údajů",
  "settings.russian": "ruština",
  "settings.serbian": "srbština",
  "settings.settings": "Nastavení",
  "settings.settingsPageTitle": "Nastavení - {page}",
  "settings.slovak": "slovenština",
  "settings.smallDecimals": "Malé desetinné",
  "settings.smallDecimalsDescription": "Zobrazit desetinné číslice v menší velikosti",
  "settings.spanish": "španělština",
  "settings.statusBarWidget": "Widget stavového řádku",
  "settings.statusBarWidgetDescription": "Vždy viditelná data o počasí",
  "settings.subscriptionSection": "Předplatné",
  "settings.supportSection": "Podpora",
  "settings.swedish": "švédština",
  "settings.systemTheme": "Téma systému",
  "settings.termsOfService": "Podmínky služby",
  "settings.themeDarkShort": "Tmavý",
  "settings.themeLightShort": "Světlý",
  "settings.themeSystemShort": "Systém",
  "settings.turkish": "turečtina",
  "settings.ukrainian": "ukrajinština",
  "settings.units": "Jednotky",
  "settings.unitsDescription": "Jednotky měření zobrazené v aplikaci",
  "settings.update": "Aktualizovat",
  "settings.windDirectionConvention": "Šipka směru větru",
  "settings.windDirectionConventionDescription": "Vyberte způsob zobrazení šipek směru větru",
  "settings.windDirectionMeteorological": "Směr původu",
  "settings.windDirectionMeteorologicalDescription": "Šipka ukazuje, odkud vítr fouká (meteorologická konvence)",
  "settings.windDirectionOceanographic": "Směr proudění",
  "settings.windDirectionOceanographicDescription": "Šipka ukazuje, kam vítr fouká (oceánografická konvence)",
  "stations.addAStation": "Přidat stanici",
  "stations.addToFavorites": "Přidat do oblíbených",
  "stations.addYourOwnStation": "Přidejte svou stanici",
  "stations.clearRecentLocations": "Vyčistit vše",
  "stations.clearSearch": "Vymazat hledání",
  "stations.currentLocation": "Aktuální umístění",
  "stations.customizedStationName": "Vlastní název stanice",
  "stations.favoriteLocations": "Oblíbené",
  "stations.favoriteLocationsEmpty": "Můžete přidat až 5 oblíbených míst.",
  "stations.favoriteStations": "Oblíbené stanice",
  "stations.filterStationDescription": "Nezobrazovat stanice s nespolehlivým měřením",
  "stations.filterStations": "Filtrovat stanice",
  "stations.filterStationSourceDescription": "Vyberte poskytovatele stanic, které chcete zobrazit na mapě",
  "stations.findStationsNearYou": "Najít stanice ve vašem okolí",
  "stations.hiddenStations": "Skryté stanice",
  "stations.hiddenStationsDescription": "Stanici můžete znovu zobrazit klepnutím na ikonu oka vedle ní.",
  "stations.hideStationNamed": "Skrýt {station}",
  "stations.lastSeen": "naposledy {time}",
  "stations.loadingStation": "Načítání stanice…",
  "stations.location": "Poloha",
  "stations.locationAddedToFavorites": "Poloha přidána k oblíbeným",
  "stations.locationNotGranted": "Povolení k poloze se neposkytuje. Povolte prosím přístup k vaší poloze v nastavení zařízení.",
  "stations.locationRemovedFromFavorites": "Místo odstraněno z oblíbených",
  "stations.locations": "Polohy",
  "stations.locationUnavailable": "Nepodařilo se zjistit vaši polohu. Zkontrolujte prosím nastavení zařízení.",
  "stations.maxFavoriteLocationsReached": "Můžete mít nejvýše 5 oblíbených míst. Odstraňte jedno, abyste mohli přidat další.",
  "stations.modifyFavoriteStations": "Upravit oblíbené stanice",
  "stations.modifyFavoriteStationsDescription": "Oblíbené stanice můžete přeuspořádat přetažením. Můžete je také odebrat ze seznamu.",
  "stations.myLocation": "Moje poloha",
  "stations.nearbyWeatherStations": "Blízké povětrnostní stanice",
  "stations.noLocationsFound": "Žádná místa nenalezena",
  "stations.noLongerReported": "Už není v seznamu",
  "stations.noLongerReportedBy": "{provider}: není v seznamu od {date}",
  "stations.noSearchResults": "Vašemu hledání neodpovídají žádné články",
  "stations.noStationsFound": "Žádné stanice nenalezeny",
  "stations.noWeatherStationYet": "Prozatím nevlastníte meteostanici.",
  "stations.recentLocations": "Nedávné",
  "stations.recentLocationsEmpty": "Nedávná historie je prázdná.",
  "stations.removeFromFavorites": "Smazat z oblíbených",
  "stations.removeStationNamed": "Odebrat {station} z oblíbených",
  "stations.reorderStationNamed": "Přesunout {station}",
  "stations.searchForLocation": "Vyhledat místo",
  "stations.searchForWeatherStation": "Vyhledat meteostanici",
  "stations.searchResults": "Výsledky vyhledávání",
  "stations.searchResultsEmpty": "Nebyly nalezeny žádné výsledky.",
  "stations.searchResultsFound": "{count, plural, one {Nalezen # výsledek} few {Nalezeny # výsledky} many {Nalezeno # výsledku} other {Nalezeno # výsledků}}",
  "stations.searchStationsDescription": "Zadejte město, adresu nebo název místa pro nalezení meteorologických stanic v okolí.",
  "stations.searchStationsHint": "Použijte vyhledávací pole výše k objevení meteorologických stanic kdekoli na světě.",
  "stations.selectStationForComparison": "Vyberte stanici pro srovnání",
  "stations.stationAddedToFavorites": "Meteostanice přidána do oblíbených",
  "stations.stationCount": "{count, plural, one {# stanice} few {# stanice} many {# stanice} other {# stanic}}",
  "stations.stationInformation": "Informace o stanici",
  "stations.stationName": "Název stanice",
  "stations.stationObservationsDescription": "Zobrazte nejnovější pozorování z meteorologických stanic",
  "stations.stationRemovedFromFavorites": "Meteostanice smazána z oblíbených",
  "stations.stationsLoading": "Načítání meteorologických stanic",
  "stations.stationsNear": "Stanice v okolí: {place}",
  "stations.stationType": "Typ stanice",
  "stations.statusOffline": "Offline",
  "stations.statusOnline": "Online",
  "stations.statusStale": "Zastaralé",
  "stations.tryAnotherLocation": "Nepodařilo se nám najít žádné meteorologické stanice v blízkosti tohoto místa. Zkuste hledat v jiné oblasti.",
  "stations.unhideStationNamed": "Znovu zobrazit {station}",
  "stations.weatherStation": "Meteorologická stanice",
  "stations.weatherStationCount": "{count, plural, one {# meteorologická stanice} few {# meteorologické stanice} many {# meteorologické stanice} other {# meteorologických stanic}}",
  "stations.weatherStations": "Meteorologické stanice",
  "stations.welcomeConnectService": "Vlastníte meteostanici? Připojte svou službu",
  "stations.welcomeSubtitle": "Vaše počasí, vše na jednom místě",
  "thermostat.away": "Pryč",
  "thermostat.boilerOn": "Ohřev zapnutý",
  "thermostat.hg": "Protimrazová ochrana",
  "thermostat.homeInformation": "Informace o domácnosti",
  "thermostat.homeName": "Název domácnosti",
  "thermostat.manualBoost": "Ruční zvýšení",
  "thermostat.manualSetpointUntil": "Ruční nastavení do",
  "thermostat.noThermostatYet": "Prozatím nevlastníte termostat.",
  "thermostat.relay": "Relé",
  "thermostat.room": "Pokoj",
  "thermostat.rooms": "Pokoje",
  "thermostat.smartThermostat": "Chytrý termostat",
  "thermostat.smartValve": "Inteligentní ventil",
  "thermostat.whenBackHome": "Kdy se vrátíte domů?",
  "units.celsius": "Celsius",
  "units.fahrenheit": "Fahrenheit",
  "units.inch": "Palce",
  "units.inchOfMercury": "Palce rtuti",
  "units.kelvin": "Kelvin",
  "units.kilometerPerHour": "Kilometry za hodinu",
  "units.knot": "Uzly",
  "units.meterPerSecond": "Metry za sekundu",
  "units.milePerHour": "Míle za hodinu",
  "units.millibar": "Milibary",
  "units.millimeter": "Milimetry",
  "units.millimeterOfMercury": "Milimetry rtuti",
  "weatherConditions.blizzard": "Sněhová vánice",
  "weatherConditions.blowingDust": "Zvířený prach",
  "weatherConditions.blowingSnow": "Zvířený sníh",
  "weatherConditions.breezy": "Mírný vítr",
  "weatherConditions.clear": "Jasno",
  "weatherConditions.cloudy": "Zataženo",
  "weatherConditions.drizzle": "Mrholení",
  "weatherConditions.flurries": "Slabé sněžení",
  "weatherConditions.foggy": "Mlha",
  "weatherConditions.freezingDrizzle": "Mrznoucí mrholení",
  "weatherConditions.freezingRain": "Mrznoucí déšť",
  "weatherConditions.frigid": "Silný mráz",
  "weatherConditions.hail": "Krupobití",
  "weatherConditions.haze": "Zákal",
  "weatherConditions.heavyRain": "Silný déšť",
  "weatherConditions.heavySnow": "Silné sněžení",
  "weatherConditions.hot": "Horko",
  "weatherConditions.hurricane": "Hurikán",
  "weatherConditions.isolatedThunderstorms": "Ojedinělé bouřky",
  "weatherConditions.mixedRainAndHail": "Déšť s kroupami",
  "weatherConditions.mostlyClear": "Převážně jasno",
  "weatherConditions.mostlyCloudy": "Převážně zataženo",
  "weatherConditions.mostlySunny": "Převážně slunečno",
  "weatherConditions.notAvailable": "Povětrnostní podmínky nejsou k dispozici",
  "weatherConditions.partlyCloudy": "Polojasno",
  "weatherConditions.rain": "Déšť",
  "weatherConditions.rainSleet": "Déšť s ledovými kuličkami",
  "weatherConditions.rainSnow": "Déšť se sněhem",
  "weatherConditions.scatteredShowers": "Rozptýlené přeháňky",
  "weatherConditions.scatteredSnowShowers": "Rozptýlené sněhové přeháňky",
  "weatherConditions.scatteredThunderstorms": "Rozptýlené bouřky",
  "weatherConditions.showers": "Přeháňky",
  "weatherConditions.sleet": "Ledové kuličky",
  "weatherConditions.smoke": "Kouř",
  "weatherConditions.snow": "Sněžení",
  "weatherConditions.snowShowers": "Sněhové přeháňky",
  "weatherConditions.strongStorms": "Silné bouřky",
  "weatherConditions.sunny": "Slunečno",
  "weatherConditions.thunderstorms": "Bouřky",
  "weatherConditions.tornado": "Tornádo",
  "weatherConditions.tropicalStorm": "Tropická bouře",
  "weatherConditions.windy": "Větrno",
  "weatherConditions.wintryMix": "Smíšené zimní srážky",
  "weatherMap.clusterMarkerName": "{metric} {value}, medián z {count, plural, one {# stanice} few {# stanic} many {# stanic} other {# stanic}}, přiblížit",
  "weatherMap.legendHeavy": "Silné",
  "weatherMap.legendLight": "Slabé",
  "weatherMap.legendLightningHelp": "Barva ukazuje stáří každého blesku za posledních {minutes} minut — nejnovější bíle, nejstarší tmavě červeně.",
  "weatherMap.legendNewest": "Nejnovější",
  "weatherMap.legendOldest": "Nejstarší",
  "weatherMap.legendStationsHelp": "Barva značky odráží hodnotu vybrané veličiny.",
  "weatherMap.lightningDataAttribution": "Data o blescích: Blitzortung.org",
  "weatherMap.lightningStrikes": "Údery blesků",
  "weatherMap.lightningStrikesDescription": "Zobrazit údery blesků v reálném čase na mapě",
  "weatherMap.mapLayers": "Vrstvy mapy",
  "weatherMap.mapLegend": "Legenda mapy",
  "weatherMap.mapMode": "Režim mapy",
  "weatherMap.mapNameForecast": "Předpovědní mapa, {model}, {variable}",
  "weatherMap.mapNameObservations": "Mapa počasí, pozorování",
  "weatherMap.modeForecast": "Předpověď",
  "weatherMap.modeObservations": "Pozorování",
  "weatherMap.radarDataAttribution": "Data z radaru: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.radarTime": "Čas radaru",
  "weatherMap.rainRadar": "Dešťový radar",
  "weatherMap.rainRadarDescription": "Zobrazte na mapě překrytí dešťového radaru",
  "weatherMap.resetBearing": "Tažením mapu otočíte, kliknutím ji natočíte k severu",
  "weatherMap.showingForecast": "Zobrazena předpověď: {model}, {variable}",
  "weatherMap.signInForecastBody": "S účtem SmartMixin jsou mapy GFS zdarma. S Premium jsou dostupné další modely.",
  "weatherMap.signInForecastTitle": "Přihlaste se a uvidíte předpovědní mapy",
  "weatherMap.stationMarkerName": "{metric} {value}, jedna stanice",
  "weatherMap.stationMarkersHint": "Šipkami se přesunete mezi stanicemi",
  "weatherMap.stationMarkerWindValue": "{speed}, směr {direction}",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain je další zdroj dat poskytovaný prostřednictvím systému Tempest Weather System s technologií Nearcast. Data NC Rain jsou odhadem průměrné akumulace srážek kolem vašeho Tempest na úrovni sousedství",
  "weatherMap.weatherMap": "Mapa počasí",
  "weatherMap.weatherMapMetaDescription": "SmartMixin nabízí interaktivní mapy počasí a radaru pro povětrnostní podmínky po celém světě.",
  "weatherMap.zoomIn": "Přiblížit",
  "weatherMap.zoomOut": "Oddálit",
  "weatherWarnings.activeNow": "Aktivní nyní",
  "weatherWarnings.agencyMessage": "Zpráva meteorologické služby",
  "weatherWarnings.areaCovered": "Zasažená oblast",
  "weatherWarnings.areaThisLocation": "{area} (toto místo)",
  "weatherWarnings.areaYourStation": "{area} (vaše meteorologická stanice)",
  "weatherWarnings.badgeLabel": "{others, plural, =0 {Oficiální varování, {severity}: {hazard}} one {Oficiální varování, {severity}: {hazard}, a ještě #} few {Oficiální varování, {severity}: {hazard}, a ještě #} other {Oficiální varování, {severity}: {hazard}, a ještě #}}",
  "weatherWarnings.badgeLabelUpcoming": "{others, plural, =0 {Nadcházející oficiální varování, {severity}: {hazard}} one {Nadcházející oficiální varování, {severity}: {hazard}, a ještě #} few {Nadcházející oficiální varování, {severity}: {hazard}, a ještě #} other {Nadcházející oficiální varování, {severity}: {hazard}, a ještě #}}",
  "weatherWarnings.crumb": "Oficiální varování",
  "weatherWarnings.emptyBody": "Národní meteorologická služba nemá pro toto místo žádné platné varování. Znovu kontrolujeme každých několik minut.",
  "weatherWarnings.emptyTitle": "Žádná oficiální varování",
  "weatherWarnings.ended": "Skončeno",
  "weatherWarnings.endedAt": "Toto varování skončilo {time}.",
  "weatherWarnings.errorBody": "Zkontrolujte připojení. Znovu to zkoušíme každých několik minut.",
  "weatherWarnings.errorTitle": "Oficiální varování se nepodařilo načíst",
  "weatherWarnings.fromTime": "Od {time}",
  "weatherWarnings.hazardAirQuality": "Kvalita ovzduší",
  "weatherWarnings.hazardAvalanche": "Laviny",
  "weatherWarnings.hazardCoastalEvent": "Pobřežní jevy",
  "weatherWarnings.hazardFlood": "Povodně",
  "weatherWarnings.hazardFog": "Mlha",
  "weatherWarnings.hazardForestFire": "Lesní požáry",
  "weatherWarnings.hazardHighTemperature": "Vysoké teploty",
  "weatherWarnings.hazardLowTemperature": "Nízké teploty",
  "weatherWarnings.hazardOther": "Jiné nebezpečí",
  "weatherWarnings.hazardRain": "Déšť",
  "weatherWarnings.hazardSnowIce": "Sníh a náledí",
  "weatherWarnings.hazardThunderstorm": "Bouřky",
  "weatherWarnings.hazardUv": "UV záření",
  "weatherWarnings.hazardWind": "Vítr",
  "weatherWarnings.hideHazards": "Skrýt jevy",
  "weatherWarnings.issuedBy": "Vydal: {sender}",
  "weatherWarnings.lastUpdate": "Poslední aktualizace: {time}",
  "weatherWarnings.mapLabel": "{count, plural, =1 {Mapa zasažené oblasti: {area}.} other {Mapa zasažených oblastí, celkem #. Zvýrazněno: {area}.}}",
  "weatherWarnings.mapLabelNoHighlight": "{count, plural, =1 {Mapa zasažené oblasti.} other {Mapa zasažených oblastí, celkem #.}}",
  "weatherWarnings.mapUnavailable": "{count, plural, =1 {Mapa není k dispozici. Oblast je uvedena níže.} other {Mapa není k dispozici. Seznam oblastí (#) je uveden níže.}}",
  "weatherWarnings.moreHazards": "+ další {count}: {hazards}",
  "weatherWarnings.notInLanguage": "Není k dispozici v jazyce {language}. Zobrazeno tak, jak to zveřejnila meteorologická služba.",
  "weatherWarnings.openOn": "Otevřít na {site}",
  "weatherWarnings.otherAreas": "{count, plural, one {+ # další oblast} few {+ # další oblasti} other {+ # dalších oblastí}}",
  "weatherWarnings.severityExtreme": "Extrémní",
  "weatherWarnings.severityFrom": "{severity} od {time}",
  "weatherWarnings.severityMinor": "Nízký",
  "weatherWarnings.severityModerate": "Střední",
  "weatherWarnings.severityNow": "{severity} nyní",
  "weatherWarnings.severitySevere": "Vysoký",
  "weatherWarnings.severityUntil": "{severity} do {time}",
  "weatherWarnings.showAllAreas": "{count, plural, one {Zobrazit # oblast} few {Zobrazit všechny # oblasti} other {Zobrazit všech # oblastí}}",
  "weatherWarnings.showAllOnMap": "{count, plural, one {Zobrazit # oblast na mapě} few {Zobrazit všechny # oblasti na mapě} other {Zobrazit všech # oblastí na mapě}}",
  "weatherWarnings.showHazards": "Zobrazit jevy",
  "weatherWarnings.showPeriods": "{count, plural, one {Zobrazit # období} few {Zobrazit všechna # období} other {Zobrazit všech # období}}",
  "weatherWarnings.source": "Zdroj: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, poté {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# oficiální meteorologické varování} few {# oficiální meteorologická varování} other {# oficiálních meteorologických varování}}. {hazards}",
  "weatherWarnings.spokenLabelArea": "{label} {area}.",
  "weatherWarnings.spokenPeriod": "{severity}: {range}",
  "weatherWarnings.title": "Oficiální meteorologická varování",
  "weatherWarnings.todayAt": "{time} dnes",
  "weatherWarnings.tomorrow": "Zítra",
  "weatherWarnings.tomorrowAt": "{time} zítra",
  "weatherWarnings.upcoming": "Nadcházející",
  "weatherWarnings.viewAll": "Všechna oficiální varování",
  "weatherWarnings.whatToDo": "Co dělat"
}
